module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "viewBox": "0 0 353 353",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "2"
    }
  }, [(_vm.male) ? [_c('path', {
    attrs: {
      "d": "M51.7 51.7a176.6 176.6 0 11249.6 249.9A176.6 176.6 0 0151.7 51.7z",
      "fill": "#f6ece6"
    }
  }), _c('path', {
    attrs: {
      "d": "M51.7 51.7a176.6 176.6 0 11249.6 249.9A176.6 176.6 0 0151.7 51.7z",
      "fill": "#cde3e1"
    }
  }), _c('path', {
    attrs: {
      "d": "M144 235.9s23.3 25.8 28.8 27.3c5.4 1.6 46.5-26.9 47.6-41.3l.9-25.6-79 13.5 1.7 26z",
      "fill": "url(#_Linear1)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M182.9 249.8c-3.1.6-14.6-.5-15.7-.4-1 .1-18.4-13.6-18.5-14.4a422 422 0 00-5.3-14.8s-.4 13.4 1.3 16.5c1.6 3 20.7 16.6 20.7 16.6l14.4 2s21.4-6.7 26.6-12c4.9-5 13-30 13.6-32.3-2 5.7-5 11.1-8.7 16-3.8 5.2-27.9 22.7-28.4 22.8z",
      "fill": "url(#_Linear2)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M220 211z",
      "fill": "url(#_Linear3)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M195.9 260.1l-38.9-1.9s-51.4 10.1-51.6 12.2l-9.7 63a177 177 0 00149 6l-3-101.3-45.8 22z",
      "fill": "#f0eff3",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M59.1 267.3c0-1 .3-2.1.7-3.1-3.7-1.5-10.2 12.6-11 34a174 174 0 0013 12.4c-2-26.2-4.4-39.4-2.7-43.3z",
      "fill": "#52325a",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M59.9 264.2c-3.2 6.4-3.3 23-2.4 42.6l5.6 5c-3.9-29.5-3.3-47.6-3.3-47.6z",
      "fill": "#231128",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M231.8 299.6c-17.5-28.1-111.1-24.4-124.9-14.8a100.7 100.7 0 00-28.2 38.7 177 177 0 00164.9 16.3 78.2 78.2 0 00-11.8-40.2z",
      "fill": "url(#_Linear4)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M137.8 253.6l-2.1-16.7-29 70.8-3 29.7c4 1.7 8 3.4 12 4.9l2.6-19c7.6-48.8 19.5-69.7 19.5-69.7z",
      "fill": "url(#_Linear5)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M177.4 286.6c.1-.7 3.6-2.6 6.6-7.3a46 46 0 004.7-12.3l-3.2-6.5c-19.7 19.6-13.1 39.8-13.3 49l-7.7 43.1 9.3.4.5-5c1.3-9.7 2.2-56.6 3.1-61.5z",
      "fill": "url(#_Linear6)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M222.2 232.8s-7 73-8.5 76.5c-.6 1.3-3.1 18.9-5.8 41A175 175 0 00238 342l-3.3-106.2-12.5-3z",
      "fill": "url(#_Linear7)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M310 292l1.3-31.8s-52.4-13.1-58.1-17.1c-5.7-4-31-14.5-31-14.5s5.7 12.9 6 20.8c.4 7.1-4.8 71.2-7.6 98 34.8-8.9 66-28.2 89.4-55.4z",
      "fill": "#52325a",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M171.9 256.9l-29.6-15.4-11 5.3c.6 27 3.2 38 3.2 38 1.2-.5 31.4-25.7 31.4-25.7l9.4 1.1 23.2 31.7c9.8-9.5 33.5-49.4 33.5-49.4l-47 16.2-13.1-1.8z",
      "fill": "url(#_Linear8)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M121.9 274.3c5.5-14.5 2.5-34.7 2.5-34.7-32.4 13.3-53 20.5-64.6 24.6-1.6 15.8-1 29.2.9 45.5a176.4 176.4 0 0043.7 28l1.2-8.8c.5-4.6 13.1-46.4 16.3-54.6z",
      "fill": "#52325a",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M132.7 235.6L92 255.1l8.3 4.5-17 2.1s3.5 34.6 5.2 67.8c4.4 2.5 9 4.9 13.6 7 3-31.6 6.5-63.8 9.8-69 6-9.6 21-31.9 21-31.9z",
      "fill": "#231128",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M138.9 236.6l-.8-6.2-42.5 22 17 7-22.8 2.7s3.5 52.4 3.8 70.3c5.3 2.8 10.8 5.4 16.4 7.7l1.2-8.4c11.8-67.6 27.7-95.1 27.7-95.1z",
      "fill": "#52325a",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M278 260.2l-14.6-1.6 6.4-5-15.8-8.2-22 98.7c6.3-2 12.4-4.4 18.4-7.2.2-1 .6-2 1.2-2.9 1.6-1 26.4-73.8 26.4-73.8z",
      "fill": "#231128",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M157.5 280.3s-14.8 47.5-20 68.4c10.4 2.3 20.8 3.7 31.4 4.2 1.3-17.4 6.4-73.8 6.4-73.8l-17.8 1.1z",
      "fill": "url(#_Linear9)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M156.7 283c14.3 2.7 17.7 5.7 17.7 5.7l.9-8.6-17.6-1.2-1 4.1z",
      "fill": "#9c1c20",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M171 254.7c-2.4-.5-4.8-.5-7.2 0a28.8 28.8 0 01-6.8 3.5c-2.4.9-4.6 14.2.4 22.6 5.4.6 11.3 1.8 17.3 2.2 9.8-5.2 11.6-18 11.6-18l-7.7-9.2s-3.8-.4-7.7-1.1z",
      "fill": "url(#_Linear10)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M253.7 258.8l13.8-8.6s-25-14.3-38.8-21.6c0 0-4.5 37.8-4.5 41.9 0 2.8-4 46.8-7.1 77.9 8.7-2 17.2-4.8 25.5-8.2 10.4-29.5 29-79.3 29-79.3l-17.9-2z",
      "fill": "#52325a",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M166 253.6H158s-2.7 8.2-2.7 13l12-11.3 8.5 1 9 14c1-2.3 1.7-4.6 2.2-7-1.7-2.3-7-8-7-8l-13.8-1.7z",
      "fill": "url(#_Linear11)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M212 228.7c-4.3 4.9-21 22.7-32.2 26.6 0 0 17.8 25.9 20.1 29.5l16-21.5s14.2-22 14.2-30.5c0-9.1-9.3-24-9.3-24s-4.5 15-8.8 20zM143.3 220.2s-7.4 9.5-7.6 16.7c-.3 6.1-.5 42.5-.5 42.5s18.9-23 30.9-25.8c0 0-10.9-7.7-15.7-12.6-4.8-5-7-20.8-7-20.8z",
      "fill": "#f0eff3",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M149.6 239.7c-.8-1.7-5-10.2-5.7-18.2 0 0-3 14.1 2.7 20a73.4 73.4 0 0019.5 12s-15.8-12.1-16.5-13.8z",
      "fill": "url(#_Linear12)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M197.2 243.5c-10 9.3-17.4 11.8-17.4 11.8s3 .8 18.1-8.5c3.6-2.1 15.5-14 18-17 2.6-3 5-21 5-21S215 224 214 226c-1 2-9.6 11-16.8 17.6z",
      "fill": "url(#_Linear13)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M186.6 265l13.3 19.8 12.8-17.1c-9.8 4.8-26.1-2.6-26.1-2.6z",
      "fill": "url(#_Linear14)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M135.5 249.4l-.3 30c1.5-1 13.5-14.3 13.5-14.3-11.3-3.6-13.2-15.7-13.2-15.7z",
      "fill": "url(#_Linear15)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M306.2 296.3l5.2-35.7c-13.6 13.1-18 28.5-24.9 54 7-5.6 13.6-11.7 19.7-18.3z",
      "fill": "url(#_Linear16)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M319.7 279.8c-3.1-11.6-6.4-21.4-8.8-19.4-8.2 6.8-14.7 28.4-19.4 50 10.5-9 20-19.3 28.2-30.6z",
      "fill": "#231128",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M317.2 271a114 114 0 00-2.1 15l4.5-6.1-2.4-8.8z",
      "fill": "url(#_Linear17)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M104.9 137.2c-7.5 1.4-5.9 6.5-2.6 15.4 3.2 23.7 9.3 28.5 11.9 27 4.7-2.6-.2-44-9.3-42.4z",
      "fill": "#f0c999",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M111 171s-3.6-4.4-2.2-12.8c3.3-19.6-8.7-21.6-6.4-8 0 0 1.9-6.3 3.3-4.3 1.8 2.4-2 3.5-.4 13.9.8 5.3 5.6 11.2 5.6 11.2z",
      "fill": "url(#_Linear18)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M245.8 137c7.6 1 6.2 6.2 3.5 15.3-1.9 23.8-7.7 28.8-10.4 27.5-4.8-2.4-2.2-44 7-42.8z",
      "fill": "#f0c999",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M241.7 171s3.3-4.6 1.4-12.9c-4.4-19.4 7.5-22 6-8.2 0 0-2.3-6.2-3.6-4.2-1.7 2.6 2.3 3.5 1.3 13.8-.6 5.5-5 11.5-5 11.5z",
      "fill": "url(#_Linear19)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M240 135.9c2.2-55.8-15-63.3-19.8-69-10-11.6-25.5-16.7-52.2-16 0 0-34.7 1.2-43.4 20.2-9.3 20.3-11 48.3-10.1 74.5 1 31.9 1 40.3 3.7 47 1.8 4.8 5 9 9.1 12.2 9.9 7.8 22.9 22.5 30.9 29a44.9 44.9 0 0041.8-3.5c8.9-6 18.1-13.7 29-24.5a28.6 28.6 0 007.9-16.5c0-4.5 2.6-21.4 2.5-24.7-1-18 0-13.2.5-28.7z",
      "fill": "#f7d9ab",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M212.8 188.6c11 .8 24.3-.6 26.6-23.4 1.3-13-1.1-19.8-6.6-20.8A65.6 65.6 0 00198 151c-14.5 7.6-4.5 36.4 15 37.7z",
      "fill": "url(#_Radial20)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M152.1 149.8c-3.1-1.1-27-6.6-34.1-4.5-4 1.2-5.4 10.4-4.7 19a71 71 0 002.2 13.4c4.6 12.8 24.1 13.4 34.2 9.8 17.3-6 18.3-31.9 2.4-37.7z",
      "fill": "url(#_Radial21)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M231.6 150.7c-2-1.2-3.5.5-7.6 1.8-4.1 1.4-15 3.4-9.9 6.2 5.7 3.2 13.7-1.1 14.7-2 1-.8 5.2-4.7 2.7-6z",
      "fill": "url(#_Linear22)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M200.9 195l-1 .9 1-.9z",
      "fill": "url(#_Linear23)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M196.6 177.4c11 9 6.6 15.4 4.3 17.6 4.2-3.6 10-7.5 9.6-9-1.4-5.8-14-8.6-14-8.6z",
      "fill": "url(#_Linear24)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M199.7 188.3s5.7-1.3 6.2-1.7c.4-.6.8-1.2 1-1.9l-3.6 1.1-3.6 2.5z",
      "fill": "#e1b58c",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M145.6 186.8c.2 1.7 5.1 6 8.4 9.4 0 0-8.7-9.3 3.3-17.7 0 0-12.6 2.4-11.8 8.3z",
      "fill": "url(#_Linear25)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M148.5 185.1c.2.7.5 1.3 1 1.9.4.3 6.1 1.7 6.1 1.7l-3.5-2.5-3.6-1.1z",
      "fill": "#e1b58c",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M166.2 209.8c15-1.7 25.1.2 25.1.2-11.3-7.1-25.1-.2-25.1-.2z",
      "fill": "url(#_Linear26)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M149.8 185.8c.3.3.6.8 1 1 7.2 3.1 7.3 6.2 10.3 7.8 11 6 23.8 4.5 32.3-.2 5-2.8 5.6-6 11.5-8.3.5-.1.8-.4 1-.9-31.6 7.7-56 .6-56 .6z",
      "fill": "#96282d",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M178.2 200.8c-4.3 0-8.5-.8-8.5 0 0 .9 3.7 2.7 8 2.7s8.5-1.8 8.5-2.6c0-.9-3.8 0-8 0z",
      "fill": "#fdddb3",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M190.4 192.4c-4.3 1-8.8 1.5-13.3 1.6-4.8 0-9.5-.6-14.2-1.5-1.3-.3-1.9 2-1.9 2 4 3 8.9 4 16.6 4.2 10.3 0 16-4.4 16-4.4s-1.5-2.3-3.2-2z",
      "fill": "url(#_Linear27)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M162.4 202c16.5 13 32.2-1 32.2-1-16.6 8.9-32.2 1-32.2 1z",
      "fill": "url(#_Linear28)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M157 187.3a4.7 4.7 0 002.9 4c1.5.6 5.1 3.3 19 3 14-.5 16.7-3.9 17.3-4.5.8-.8 1.4-1.8 1.7-2.9.4-1.1-20.9 4.1-40.9.4z",
      "fill": "url(#_Linear29)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M157 187c0 .7.2 1.4.5 2a83.3 83.3 0 0039.6-.3l1-2c.1-.8-9.5 3-41.2.4z",
      "fill": "#f3eceb",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M148.1 185s2 1.2 1.7.8c0 0 24.5 7.2 56-.5l1.8-.9c-17.2 2.8-59.5.6-59.5.6z",
      "fill": "url(#_Linear30)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M127.1 153c-4.1-1.1-5.7-2.7-7.6-1.5-2.4 1.5 2 5.3 3 6 1 .8 9.3 4.6 14.8 1.2 5-3-6-4.6-10.2-5.7z",
      "fill": "url(#_Linear31)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M190.3 122.7c-.8 5.5-5.8 25.4-2.6 27.3 19.9 11.8 41.6-3.1 41.6-3.1 5.6-32.7-39-24.2-39-24.2z",
      "fill": "url(#_Linear32)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M122.9 147.4s21.1 14.1 41.5 1c3-2-3-19.8-4-25.2 0 0-38-11.2-37.5 24.2z",
      "fill": "url(#_Linear33)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M145.2 132.5c-3.4-.2-10.5.9-12.8 2.7-4.3 3.3-5.8 6.3-5.4 10 0 1.2 4.6 5.4 14.3 6.2 7.2.5 18.6 0 21.4-3 1.3-1.5-.4-7.3-1-9.3-1-4-6.4-6-16.5-6.6z",
      "fill": "url(#_Linear34)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M152.2 136.5c-15.4-1.8-14.5.5-20.8 7.7.2.8.5 1.6 1 2.4 1.6 2 3.9 3.3 6.4 3.7 10 1.9 13.1.5 17.4-.4 1.8-.3 3.8-2 3.7-2.8.2-2-.2-4.1-1-6-.9-2.2-2.9-4.1-6.7-4.6z",
      "fill": "url(#_Linear35)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M131.4 144.2c.1.8.5 1.6 1 2.3 11-7 23-5.3 26.6-5.4-6.3-4-15.5-3.1-20-3.6-5.8-.7-7.6 6.6-7.6 6.6z",
      "fill": "#ddd",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M146 137.4c-5 .3-9.2 4.2-8.6 9.1 0 1.4.6 2.7 1.5 3.8a32.5 32.5 0 0015 .1c.7-1.3 1.2-2.7 1.3-4.3.3-5.1-3.2-9-9.2-8.7z",
      "fill": "url(#_Linear36)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M145.6 136.8a9 9 0 00-8.1 7c-.8 4 6-2.9 16.4-2.8 0 0-2.9-4.7-8.3-4.2z",
      "fill": "url(#_Linear37)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M146.1 138.8c-2.8.2-5 2.5-5 5.3 0 3 2.3 5.3 5.2 5.3 3 0 5.3-2.3 5.3-5.3s-2.5-5.3-5.5-5.3z",
      "fill": "url(#_Radial38)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M155.8 137.4c-5.5-3-14-2.5-19.4-.2-3 1-5 3.8-5 7 0 3.1 2.8-3.2 12-4.5 5.2-.8 10.6-.3 15.6 1.4a8.4 8.4 0 00-3.2-3.7z",
      "fill": "url(#_Linear39)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M150.6 144.6a2.3 2.3 0 00-1.1 3c.6 1 2 1.5 3 .9a2.3 2.3 0 001.2-3c-.6-1.1-2-1.5-3.1-1zM145.7 142.3a1.8 1.8 0 00-.9 2.4c.5.9 1.6 1.2 2.5.7a1.8 1.8 0 00.9-2.4 1.8 1.8 0 00-2.5-.7z",
      "fill": "#fff",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M219.3 135.2c-2.4-1.9-9.5-2.9-12.9-2.7-10 .6-15.6 2.7-16.6 6.6-.5 2-2.2 7.8-.9 9.3 2.8 3 14.2 3.5 21.4 3 9.7-.8 14.2-5 14.3-6.2.4-3.7-1.1-6.7-5.3-10z",
      "fill": "url(#_Linear40)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M199.4 136.5c-3.8.5-5.8 2.4-6.7 4.6a13 13 0 00-1 6c0 .7 2 2.5 3.7 2.8 4.2.9 7.4 2.3 17.4.4 2.5-.5 4.8-1.8 6.4-3.8.5-.7.9-1.5 1-2.4-6.3-7.1-5.3-9.4-20.8-7.6z",
      "fill": "url(#_Linear41)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M212.7 137.4c-4.6.5-13.8-.4-20 3.7 3.5 0 15.5-1.5 26.6 5.4.5-.7.8-1.5.9-2.3.1-.9-1.8-7.4-7.5-6.7z",
      "fill": "#ddd",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M205.7 137.4c-6-.3-9.6 3.6-9.3 8.7.2 1.6.6 3 1.4 4.3a32.7 32.7 0 0015-.2c.9-1 1.4-2.3 1.5-3.7.6-5-3.6-8.8-8.7-9z",
      "fill": "url(#_Linear42)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M206 136.8c-5.4-.5-8.3 4.2-8.3 4.2 10.4 0 16.4 2.8 16.4 2.8a9 9 0 00-8.1-7z",
      "fill": "url(#_Linear43)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M205.5 138.8a5.3 5.3 0 00-5.2 5.3c0 3 2.3 5.4 5.3 5.4 2.8 0 5.2-2.4 5.3-5.3 0-3-2.5-5.3-5.4-5.3z",
      "fill": "url(#_Radial44)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M215.2 137.2c-5.4-2.2-14-2.8-19.4.2a8.4 8.4 0 00-3.1 3.7c5-1.7 10.3-2.2 15.5-1.4 9.2 1.3 12 4.4 12 4.4 0-3.1-2-6-5-7z",
      "fill": "url(#_Linear45)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M210 144.3a2.4 2.4 0 00-2.1 2.7 2.3 2.3 0 002.6 2 2.4 2.4 0 002-2.6 2.3 2.3 0 00-2.6-2zM204.8 142.1c-1 .1-1.7 1-1.7 2s.8 1.8 1.9 1.8a1.9 1.9 0 001.8-2.1c0-1-1-1.7-2-1.7z",
      "fill": "#fff",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M218.2 122.7c-12-3.6-17-3.3-26.2-1.7-3 .5-2.7 5.8.7 6.1 6.4.7 29.6-2.3 29.6-2.3s1.5-.4-4.2-2z",
      "fill": "url(#_Linear46)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M158.8 121c-9-1.5-14.1-1.9-26 1.8-5.7 1.7-4.2 2-4.2 2s23.2 3 29.6 2.4c3.4-.4 3.8-5.7.6-6.2z",
      "fill": "url(#_Linear47)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M112.5 160.1c.5 12.3 2.5 24.4 4 30.2 1.4 5.2 4.2 9.9 8 13.6a521 521 0 0022.6 19.5c-1.9-2.7-17.9-21.2-20.7-25.4-11-16.3-13.9-37.9-13.9-37.9z",
      "fill": "url(#_Linear48)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M206.8 225.4c4-3.2 14-11.3 22.5-19.4 4-3.8 6.6-10.6 7.7-15 1.1-4.5 2.7-30.2 2.7-30.2-1.2 11.1-4.5 27-10.4 37.7-6 10.6-20.2 23.8-22.5 27z",
      "fill": "url(#_Linear49)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M223.3 76c-24.4-17-89.7-.2-96.4 0-6.6.1-13.4 84.6-13.4 84.6s6.5-18 8.9-28c2.4-10.1 3.4-34.1 12-42.6 24.9-24.4 69-14 79.7-4.2 11.4 10.5 13.4 36.9 15.7 43 2.4 6.3 9 28.3 9 28.3s8.8-64-15.6-81z",
      "fill": "url(#_Linear50)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M231 64.8s4.7-13.7-5.8-23c0 0 3.5 3.5 0 9.3 0 0-11.2-23.9-45.3-25.1l6.7 7.6s-31.4-12.1-59 4.8c0 0 5.2 2.5 8.2 5.8-17-1.2-25.9 8.9-30.3 19.5 0 0 10.5-6 19.8 1.1 0 0-18.8-3.7-25.5 15.9 0 0 11.1-11.3 18.5 0 0 0-12.7-1.6-19 20.4 5.3-8.1 9.1-3.5 9.1-3.5s-6.4 12.6-2 39.8c0 0 6 2 6.8 18.7 0 0 6.3-64.6 18.1-72.5 30.1-19.9 77.1-10.2 84-5.2 21.8 15.6 24.3 78 24.3 78s-.1-20 7-19.2c0 0 16-58-15.6-72.4z",
      "fill": "url(#_Linear51)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M231 64.8s5.7-13.3-5.8-23c0 0 11.3 15.4 1 25 0 0 15.3 4.3 23.9 29.7 0 0-.3-24.7-19.1-31.7z",
      "fill": "url(#_Linear52)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M180 26l6.6 7.6v-3.1s13.6-3.6 38.6 20.6c0 0-9.6-23.9-45.3-25.1z",
      "fill": "url(#_Linear53)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M127.7 38.4c3 1.4 5.8 3.3 8.1 5.8l-.7-5.7a61 61 0 0163.4 5.4c-15.8-25.5-69.8-11.6-70.8-5.5z",
      "fill": "url(#_Linear54)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M105.5 63.7s4.9-2 6.8-2.1c0 0 2.5-16.3 23.5-17.4 0 0-20.6-4-30.3 19.5z",
      "fill": "url(#_Linear55)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M133.7 184.4c-10.3-3-16.1-40.6-16.1-40.6-5.2 12.8 9.8 53.4 18.5 52.1 8.6-1.3 18.5-19.6 18.5-19.6s-12 10.6-20.9 8z",
      "fill": "url(#_Linear56)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M99.8 80.7a45 45 0 014.6-3.4c1.6-1 4.4-13.7 21-12.5 0 0-19.1-4.2-25.6 15.9z",
      "fill": "url(#_Linear57)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M194.6 210c-4 3.3-20.7 7.6-32.2 1.2-9.3-5.2-13.2-22.9-13.2-22.9.2 13.1 3.8 22.8 8.1 28.4 4.4 5.7 29.9 5.2 41.6-2.4 11.7-7.7 8-27.6 8-27.6.1 6.3-5.3 17.6-12.3 23.3z",
      "fill": "url(#_Linear58)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M224.2 181.3c-8.7 4.5-21.1-2.8-21.1-2.8s14 27.3 24.4 14.6c10.3-12.8 7.2-55 7.2-55s-1.9 38.6-10.5 43.2z",
      "fill": "url(#_Linear59)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M99.4 101s2.7-4 6.1-4.7c0 0-.6-11 12.9-15.6 0 0-14.2-1.6-19 20.4z",
      "fill": "url(#_Linear60)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M234.9 138.8c-1.7 38.6-6.1 48.6-17.1 47.1-11-1.4-11.7-6.3-17.3-9.1-3.5-1.9-42.5-2.7-45.9-.5-5.4 3.4-6.1 10.8-19.3 11.3-7.5.3-16.5-11.5-17.7-43.8-.4-10-3.6 5.4-3.6 5.4-3.4 33.5 3.3 50.7 10 63 4.8 8.8 16.3 26.7 31.6 35 6.4 3.6 12.3 3.4 21 3.2 8.6-.2 18.9-.4 26.6-5 15.6-9.1 26.3-27.5 31.4-41.1 7.6-20.4 4.5-55.8 4.5-55.8l-4.2-9.6zm-34.5 68.6c-3.2 5-10 8-18.7 8.5-15.5 1-22.1-1.4-26-7.5-4.6-7-8-22.6-5.9-23.7 1.7-.8 30.7 2.2 55.2-.5 3.6-.4 2 12.7-4.6 23.2z",
      "fill": "url(#_Linear61)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M150.5 47.8z",
      "fill": "url(#_Linear62)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M197.5 47.7s15 14.4 15.4 25.9c-7.5-4.8-28-5.3-32.2-5.2-4-5.4-12.7-17.5-30.2-20.6 2 .4 9.5 2.6 19.7 20-7-.5-20 4-22.7 4.6-2-1.3-10.3-5.7-16-5.7 0 0 8.9 4.1 9.7 7.8 0 0-9.4 3.9-14.2 12-13.9 23.3-13.8 75.4-13.8 75.4s4.8-18.5 7.3-31.9c3-15.5 3.9-33.8 9.3-41.2 13.8-18.6 64.5-22.1 85.6-8 11.6 7.7 13.5 27.8 16.9 45.3 2.9 15 7.4 36 7.4 36s.6-59.2-13.5-79.8c0 0-8.7-25-28.7-34.6z",
      "fill": "url(#_Linear63)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M182.4 150.6c.6-12.5-3.7-14.3-7-14.2-3.3.1-4.9 4.5-4.2 14 .6 9.6-1.3 13.1-.8 17.6.2 2 1.1 3.3 6.2 3.4 5.7 0 7.6-1.3 7.9-3.2.7-5.2-2.5-8.6-2-17.6z",
      "fill": "url(#_Linear64)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M183 174.9c7.6-1.9 10.6-.8 10.6-.8-4.4-3.9-10.6.8-10.6.8zM161.5 173.6s4-.7 9.9 1.4c0 0-5.8-4.5-10-1.4z",
      "fill": "#e1b58c",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M189 162.2c-.1 3.1.6 5.2-.3 7-2.2 4-7.6 5.6-11.3 5.3-2.8.3-9.3-1.1-12-5.2-1.1-1.8-.4-3.3-1-6.6 0 0-7.5 9.1-3 10.9 0 0 1.4-1 5-.7 3.7.3 3 4.3 11.3 4.4 7.3 0 5-3.4 9.6-4 4.6-.7 5.3.5 6.3 1 2.3 0 .6-7.8-4.7-12z",
      "fill": "url(#_Linear65)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M169.6 167.6c-.3 2 2.5 4.2 7.7 4.2 5.6 0 6.9-2.2 6.4-4-2.8-11.1-13-7.8-14.1-.2z",
      "fill": "url(#_Linear66)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M184.5 131.7a21.3 21.3 0 01-16.7.6c-2-1.5-46.7-2-49-.3-1.3 1 0 10.3.2 17.6.3 7.3 1 11.7 5 14.3 4 2.7 33.5 3.7 38.4.3 4.9-3.4 8.3-20 8.3-20s4.6-2.9 10.9.1c.8 2.7 3.6 16.4 8.3 19.4 4.7 3 34.5 2.3 38.4-.3 4-2.6 4.7-7 5-14.3.4-7.3 1.6-16.6.2-17.6-2.3-1.8-46.8-1-49 .2zm-25.4 29.6c-3.5 3.2-29.4.1-30.6-.3-2.8-1-3.8-2.9-4.2-5.4-.2-1.5-2.3-17-.2-18.9 2.2-1.9 41.7-1 42.5.5 1.8 3.3-4 21-7.5 24.1zm68.9-6.2c-.4 2.5-1.4 4.4-4.2 5.4-1.1.4-26.2 2.2-30.6.3-4.4-2-9.3-20.9-7.5-24.1.9-1.6 40.4-2.4 42.5-.5 2.1 1.9 0 17.3-.2 18.9z",
      "fill": "url(#_Linear67)",
      "fill-rule": "nonzero"
    }
  }), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "_Linear1",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-103.7 210.9 63.6) scale(50.89)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#daa679"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#e3b485"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c998"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear2",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-95.5 12387.2 -674.7) scale(832.244)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#daa679"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#e3b485"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c998"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear3",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-90 241 7.8) scale(.0144)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#daa679"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#e3b485"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c998"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear4",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(83.8 -56.4 202.5) scale(92.84)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#f8f7f9"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0eff3"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear5",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(15.4 5.27 -5.27 15.4 114 285.6)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f0eff3"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#e0e0e4"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear6",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(164.6 306.7) scale(24.13)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#e0e0e4"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0eff3"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear7",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(6472.8 34482.9) scale(909.625)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#e0e0e4"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0eff3"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear8",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-86.9 17174 -2067.5) scale(4580.482)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#e0e0e4"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0eff3"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear9",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(154.9 60.6 173.3) scale(31.09)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#a31e22"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#b3272c"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear10",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-21 24427.2 -9990.4) scale(938.58)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#a31e22"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#b3272c"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear11",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(153.3 2319.6 2967.6) scale(959.623)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#a31e22"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#b3272c"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear12",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(1896.271) rotate(-82.1 3.5 1)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#e0e0e4"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0eff3"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear13",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(1737.04) rotate(37.6 -6.9 10.2)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#e0e0e4"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0eff3"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear14",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-53.6 371 -50) scale(32.08)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f0eff3"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#f8f7f9"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear15",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-105.2 4317.1 3485.2) scale(1193.592)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f0eff3"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#f8f7f9"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear16",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(71.15) rotate(-87.5 4.4 0)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#272628"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#2b2a2c"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#333236"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear17",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(19 -672 1068.7) scale(9.76)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#38373b"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#333236"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear18",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(35.493) rotate(77.6 -1 3.8)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#dba779"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#e4b586"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear19",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(92.2 -951.6 3189) scale(1050.7809)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#dba779"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#e4b586"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear22",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(161 103.3 95.8) scale(20.14)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fbdbaf"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear23",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-90.8 197.4 -.2) scale(2.21)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f6d7a8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#f3cfa0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f1ca9a"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear24",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-789.2328) rotate(89.3 .7 -4.5)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f6d7a8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#f3cfa0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f1ca9a"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear25",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-810.71355) rotate(89.4 1.4 -3.8)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f6d7a8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#f3cfa0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f1ca9a"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear26",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-103.2606) rotate(74.8 -16.6 -34.2)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f6d7a8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#f3cfa0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f1ca9a"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear27",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(39.1 .67 -.67 39.1 159 195)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#e8d9d7"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".1",
      "stop-color": "#f0e6e4"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#fbf8f8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#e8d3d1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear28",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-99.8 3691.2 -1651.4) scale(199.403)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f6d7a8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#f3cfa0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f1ca9a"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear29",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(14.64) rotate(87.6 -.4 12.5)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#e8d9d7"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#efe5e4"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear30",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-286.0192) rotate(77.5 -16.1 -25.6)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f6d7a8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#f3cfa0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f1ca9a"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear31",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-173.6 1484.3 713.2) scale(562.1517)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fbdbaf"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear32",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-94.9 176 -18.4) scale(21.65)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f6d7a8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f3cfa0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear33",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-685.6246) rotate(83.6 -.4 -8.9)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f6d7a8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f3cfa0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear34",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(15.7 -433 532.1) scale(37.93)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f0c999"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#e4b586"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#dba779"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear35",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-166.5 88.7 63.9) scale(24.08)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#ece7e7"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".2",
      "stop-color": "#f6f4f4"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#fdfcfc"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear36",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(177.7 76.2 73.6) scale(24.64)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#94958d"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#c5c6c0"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear37",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(14.4 -3889 10365) scale(434.766)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#94958d"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#c5c6c0"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear39",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(26.76 -1.27 1.27 26.76 131 140)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#673024"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#53271c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#462118"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#421f16"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear40",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(1306.127) rotate(8.4 -11.7 37.8)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f0c999"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#e4b586"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#dba779"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear41",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-172.6 3306.4 984.1) scale(657.173)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#ece7e7"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".2",
      "stop-color": "#f6f4f4"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#fdfcfc"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear42",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-440.9022) rotate(-1.8 -161.6 294.6)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#94958d"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#c5c6c0"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear43",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(501.367) rotate(12.4 -6.7 33)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#94958d"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#c5c6c0"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear45",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(729.376) rotate(-.9 127.6 -492)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#673024"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#53271c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#462118"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#421f16"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear46",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(6371.4 1029.4) scale(1059.5)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#673024"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#53271c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#462118"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#421f16"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear47",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(4311 1028.8) scale(1060.46)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#673024"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#53271c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#462118"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#421f16"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear48",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-70.08) rotate(62.4 1.7 -3.4)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f6d7aa"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c998"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear49",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(70.46) rotate(-64.1 4.1 -.7)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f6d7aa"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#ffddb2"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear50",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(131.15) rotate(86.4 .6 .7)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f3d0a1"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear51",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(85.6 11024 15685) scale(20854.65)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#673024"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#53271c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#462118"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#421f16"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear52",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(225.2 69.2) scale(24.89)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#673024"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#7a3c31"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#824137"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear53",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(45.3 0 0 45.3 180 38.5)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#824137"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#7a3c31"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#673024"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear54",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(9170.5 581.6) scale(5016.89)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#824137"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#7a3c31"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#673024"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear55",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(3301.4 1110) scale(917.484)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#824137"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#7a3c31"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#673024"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear56",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-2554.85) rotate(-87.7 -2.5 -.3)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f3d0a1"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear57",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(2653.4 1244.6) scale(653.825)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#673024"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#7a3c31"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#824137"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear58",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(93.6 2505.1 7926.7) scale(807.3221)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f3d0a1"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear59",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(91.7 -68.2 7375.8) scale(3309.7972)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f3d0a1"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear60",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(1984.2 1936.1) scale(359.482)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#673024"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#7a3c31"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#824137"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear61",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(22452.167) rotate(89.2 .2 .8)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#673024"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#53271c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#462118"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#421f16"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear62",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(87.8 74.5 125) scale(6.0135)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#673024"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#53271c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#462118"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#421f16"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear63",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(5574.762) rotate(86 1.5 2.5)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#673024"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#53271c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#462118"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#421f16"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear64",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(56.87) rotate(88.6 .5 2.6)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#ffdeb3"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".2",
      "stop-color": "#fdddb1"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear65",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(86.1 1871.3 4533) scale(485.126)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f6d7a8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#f3cfa0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f1ca9a"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear66",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-82.3 186.8 -14.5) scale(14.31)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#ffdeb3"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#fbdcaf"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear67",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-89.62) rotate(84.4 .5 -2.6)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#555657"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#2b2a2d"
    }
  })], 1), _c('radialGradient', {
    attrs: {
      "id": "_Radial20",
      "cx": "0",
      "cy": "0",
      "r": "1",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-31.75 1.27 1.5875 22.5425 227.5 158)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f8c79c"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('radialGradient', {
    attrs: {
      "id": "_Radial21",
      "cx": "0",
      "cy": "0",
      "r": "1",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(1658.48 -88.2306 168.344 1144.35 7097.3 7392.7)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f8c79c"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('radialGradient', {
    attrs: {
      "id": "_Radial38",
      "cx": "0",
      "cy": "0",
      "r": "1",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(15.6 0 0 15.6 151 147.4)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#2a3a3b"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#1c2727"
    }
  })], 1), _c('radialGradient', {
    attrs: {
      "id": "_Radial44",
      "cx": "0",
      "cy": "0",
      "r": "1",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(2428.8 1701.8) scale(165.355)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#2a3a3b"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#1c2727"
    }
  })], 1)], 1)] : (_vm.female) ? [_c('path', {
    attrs: {
      "d": "M51.7 51.7a176.6 176.6 0 11249.6 249.9A176.6 176.6 0 0151.7 51.7z",
      "fill": "#f6ece6"
    }
  }), _c('path', {
    attrs: {
      "d": "M51.7 51.7a176.6 176.6 0 11249.6 249.9A176.6 176.6 0 0151.7 51.7z",
      "fill": "#f1d6d1"
    }
  }), _c('path', {
    attrs: {
      "d": "M141.4 242.2c-3.7.9-6.3 1.5-10 2.6-2.3.7-6.2 9-6 10.4l4.6 21 98-2.4s-.8-23.3-6.4-28.4c-5-4.6-41-11.8-80.2-3.2z",
      "fill": "url(#_Linear1)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M144.9 241.2c-4.6 1-10.8 2.2-13.6 3.5-2.9 1.3.6 7.7.6 7.7s1.6-8 19.1-8.9c17.6-.9 57.4-6.5 68 7.8l1.8-6.4s-7.1-4.6-21.9-5.4a550 550 0 00-54 1.7z",
      "fill": "url(#_Linear2)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M267.4 279.6c-5-.2-63-24.8-64.7-35a86.8 86.8 0 01.5-31.5l-47.5-16c2.2 17.5-5.6 42.7-10.9 53.3-3.3 6.7-20 17-39.7 22.9 3.2 3.1 36.4 53.2 63 79.5a178 178 0 0024.6-.5c24.5-18.4 71.1-58.2 74.7-72.7z",
      "fill": "url(#_Linear3)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M235.3 267c-7.2-1.2-43.3 1.5-43.3 1.5 10.1 10.7 50.5-.3 43.3-1.5z",
      "fill": "url(#_Linear4)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M163.9 268.5s-33.7 1.7-40.8 3.2c-7.2 1.4 31 7.8 40.8-3.2z",
      "fill": "url(#_Linear5)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M178 275.7c-1.5-.7-8.3-9.2-8-7.2.3 2 7.7 16.9 10.7 13.6a58 58 0 006.5-13.3c-2.2 1.1-7.7 7.6-9.2 7z",
      "fill": "url(#_Linear6)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M247.6 265.4c-15.4-3-29.9-9.4-42.3-19-1.7-1.4-3-8.6-3-15.7 0-3.1.2-7.5.5-11.6-1 1-22.3 7-24.5 7-4.8 0-28.9-16.3-30.6-19.5h-1.3s1.4 33-5 45.8c-.7 1.5-19 13.4-33 17.5-6.5 3.7 23.5 53.7 27 69.8 4.4 21 90.3 2.8 90.3 2.8s31.4-75.2 21.9-77zm-69.8 51.3c-48.9-2.8-50.9-28.3-55.3-43.2 1.7-4.1 27.5-.1 30.3-18.2 0 0 21 .6 43.8-13.8 4 35.8 36.2 22 38.9 27.2 4.2 8.6-9 50.8-57.7 48z",
      "fill": "url(#_Linear7)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M217.3 254.3l1 48.8-1 11 9.3-6-3.2-50.7-6.1-3z",
      "fill": "url(#_Linear8)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M115.6 264.2c-48.3 11.8-54.5 14.5-54.5 14.5 5.2 3 20.2 34.3 26.1 42.5 1.4 1.8 2.5 5.2 3.5 9.6a175.8 175.8 0 0036 15.1c-3.5-22.9-6.7-45.7-8-69-2.2-7.6-3.1-12.7-3.1-12.7zM265.4 269.4c-12-3.3-23-6-23-6-1.2 1.4-3 12.2-8 25 .6 15.2 2 31 1 46l-1 8.8c11.8-4 23-9.4 33.7-15.8 10.7-19.3 32-49.2 32-49.2-.8-1.1-18.7-4.5-34.7-8.8z",
      "fill": "#c32332",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M135.2 257l-8.6 4.9 2.8 44.5 6.4 2.7-.6-5.1v-47z",
      "fill": "url(#_Linear9)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M253 299.3l-18.8-2.8s-20.2 28.8-58 24.6c-38-4.2-50.1-20.6-50.1-20.6l-25 3.7c0 11.2 1 22.3 3 33.3a177 177 0 00149-1.8c-.1-10.1-3-18.3-.1-36.4z",
      "fill": "url(#_Linear10)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M300.3 278.1c-22.4-7.8-59.5-14.9-59.5-14.9 14.6 7.8 59.4 15 59.4 15z",
      "fill": "url(#_Linear11)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M111.4 265.5c-37 5.7-50.3 13.2-50.3 13.2 17-3.3 33.9-7.7 50.3-13.2z",
      "fill": "url(#_Linear12)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M61.1 278.7c-4.3 3.9-6.8 12.8-8.2 23.8 11.7 11.5 25 21.4 39.5 29.2l-.5-7c-.5-10.6-21-51.4-30.8-46z",
      "fill": "#c32332",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M57 293.9c-1 3.3-2 6.7-2.5 10.2 4 3.9 8.3 7.5 12.7 11-2.4-19.7-6-32.7-10.1-21.2z",
      "fill": "url(#_Linear13)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M88 329.3l4.6 2.6c-.6-6.6-1.2-11.8-1.8-14.4-.7-3.4-1.7 2.5-2.7 11.8z",
      "fill": "url(#_Linear14)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M129 303.7l6.5 44.5 6.2 1.4-6-41-6.7-5z",
      "fill": "url(#_Linear15)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M217.5 311.7l-2.6 37.1 5.9-1.3 3.5-40.5-6.8 4.7z",
      "fill": "url(#_Linear16)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M248.8 294.2l10.9-5.5c-4.2-17-13.1-23.4-13.1-23.4l-4.8-1.5-7.4 79.5c8.5-3 16.8-6.5 24.7-10.8 2.1-17.2 3-33.2 3-33.2l-13.3-5.1z",
      "fill": "url(#_Linear17)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M107 266.7s-7.9 3.5-13.5 25l11.1 4.8-13 5.9s1.6 14.8 4.5 31.3a176 176 0 0025.5 10.6L110 265.9l-3 .8z",
      "fill": "url(#_Linear18)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M247 293l8.9-5.9S252 269 245 264.7c-6.3-3.8-22.1-21.8-27-20.5-.4.1-1.4.3-1 1.7 0 0 1.2 3.8 2.3 9.7 1 5.9 2.4 47 2.4 47l-3.5 45.5c13-3.1 25.5-7.7 37.4-13.7 1-10.1 2.2-22.4 3.2-37.2l-11.8-4.3z",
      "fill": "url(#_Linear19)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M132 256.1c.8-6 1.6-9.4 1.6-9.4.2-1.2-.2-2-.8-2.1-4.8-1-20 17.8-26 22-6.8 4.5-9.8 23-9.8 23l9.2 5.3-11.5 4.8c1.8 14.2 3.4 26 5 35.8a175 175 0 0038.3 13.3l-6-45.6s-.8-41.1 0-47z",
      "fill": "url(#_Linear20)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M305.9 296.6a48 48 0 00-5.6-18.5c-12-2.7-22.3 31.7-30.8 39.7a33 33 0 00-7 13c16.1-9 30.8-20.6 43.4-34.2z",
      "fill": "#c32332",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M260.5 330l-.3 2 3.6-2c-.7-11.2-1.8-15.2-3.3 0z",
      "fill": "url(#_Linear21)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M304.3 298.3c-.7-3-1.4-5.2-2-6.9-2.8-8-5.2.6-7.2 15.9 3.2-2.9 6.3-6 9.2-9z",
      "fill": "url(#_Linear22)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M144.2 244c34.4 9.7 58.1-11.7 58.1-11.7l1.2-25-58.2 1.8c1.6 14.2-1.2 34.9-1.2 34.9z",
      "fill": "url(#_Linear23)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M145.5 198.6c-.6 1.1.2 2.3 1.7 2.8 2.7 1 5.2 2.3 7.5 4-2.4-3.5-8.7-7.8-9.2-6.8z",
      "fill": "url(#_Linear24)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M195.5 205c2.1-1.8 4.6-3.4 7.2-4.5 1.4-.7 2.2-2 1.4-3-.7-1.2-6.5 4-8.6 7.6z",
      "fill": "url(#_Linear25)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M160.6 213c2.9 6 18.4 14.2 29.6-.4 0 0-16 7.3-29.6.4z",
      "fill": "#f0c999",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M147 199.7c.2.1.2.2.3.4 2.3.8 4.6 1.8 6.6 3.2 1.9 1.3 3.8 10.2 21.9 9.9 9.8-.2 15.8-3.7 21.5-10.5 1.5-1.5 3.2-2.7 5-3.6l.2-.4c-4 1.1-11.9 3.9-29 3.8-8.8.1-17.7-.8-26.4-2.8z",
      "fill": "#961b27",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M189.8 204a91.8 91.8 0 01-28.9 1.3c-3-1.2-2.6 2.5-2.6 2.5 6.4 6.4 11.5 5.2 16.6 5.2 5.1.1 12.6-2 17-6 .5-1.2-.6-3.3-2-3z",
      "fill": "url(#_Linear26)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M165 203c-3-.2-6.2-.7-9.2-1.5.5.6.9 1.3 1.2 2 .7 1.4 3.8 6.2 18.3 5.9 11-.3 16.7-4.2 17.5-6.6.4-1.4 1.4-2 1.5-2.5 0 0-3.3 1.6-11 2.5-7.8.9-11.2.4-18.2.2z",
      "fill": "url(#_Linear27)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M176.7 212.5c-22.2.2-14.6-9-29.4-12.4 2.8 1.6 5.3 3.8 7.4 6.3 4.3 4.9 8 12.7 20.6 12.5 11.2-.2 17.3-8.5 20.9-13 4-5.2 6-6.8 6.2-6.8-12 3.4-8 12.7-25.7 13.4z",
      "fill": "#f86d78",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M186.2 210.2c-3.7 1.2-7.5 2-11.3 2.2-3.9.1-7.7-.5-11.4-1.8-3.4-1.7-6.5-5.4-7.1-5.9.8 1 5.7 12.8 18.2 12.5 14.5-.5 17-10.2 19.6-13.1-1.2 1.3-4.2 4.7-8 6z",
      "fill": "url(#_Linear28)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M181 212.9c-1.5.5-6.6.9-6.4 1.4.2.5 3.3 1.5 7 .4 3-.8 4.4-2.6 4.2-3-.2-.6-3.4.7-4.9 1.2z",
      "fill": "#ff9aa2",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M147.6 201c.9.4 1.5-.3 5 1 0 0-6-3-6.3-3-.4.2 0 1.4 1.3 2zM197.5 201.2c3-1.4 4-.8 4.9-1.2 1.3-.6 1.5-1.8 1.2-2-.5-.3-6.1 3.2-6.1 3.2z",
      "fill": "#961b27",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M157 203.5s6.4 3.3 19.3 3.2c5.7-.1 11.3-1.4 16.4-3.8l.7-1.7-37.3.6 1 1.7z",
      "fill": "url(#_Linear29)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M183.3 200.3c-4.3-.3-4.8.4-8 .4-3 .1-5.4-.8-9.1-.4-6 .8-12 .6-18-.5-5.9-1 2.7 1.6 15.8 4a52 52 0 0011.3 1.3c4.8 0 8.7-1 12.4-1.7 4.7-1 9.3-2.4 13.7-4.4a82 82 0 01-18.1 1.3z",
      "fill": "#f86d78",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M180.8 200.7c-2 .3-4.1.5-6.2.5-1.3 0-4.9-.5-6-.5-1 0-7.5.6-7.6 1-.3 1.4 14.5 2.2 15.9 2 1.3-.1 12.7-1.6 12.8-2.1 0-.6-7.8-1.1-8.9-.9z",
      "fill": "url(#_Linear30)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M110.3 160.5c-10.5-.3-3.2 29.8 7.1 33.2 0 0-.8-12.2-3.2-28.4 0 0-2-4.7-3.9-4.8z",
      "fill": "#f0c999",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M112.1 176.3c2-15-8.2-15.8-5.7-5.6 0 0 1.3-4.8 2.6-3.4 1.6 1.7-1.6 2.7.2 10.4 1 4 5.2 8.2 5.2 8.2s-3.1-3.2-2.3-9.6z",
      "fill": "#dba779",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M182.3 81.5c-35.8-5.4-61.3 31.8-67.4 70-3.5 21.4-2 38.8 9.6 54.3 4.8 6.3 10.8 11 17.6 15.8 4.3 3.2 11 9.9 15.6 13.1a25 25 0 0014.2 5.5c16.9.4 27.7-12.3 32.5-17 16.8-16 32.8-22.4 28.2-66.3-3.7-34.6-26.8-75-50.3-75.4z",
      "fill": "#f7d9ab",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M224.5 141.8a25 25 0 00-18.5-5.2c-26.4 2.7-26 29-28.4 44 32.3 12.8 51.2-10.6 51.2-10.6s5.5-20.6-4.3-28.2z",
      "fill": "url(#_Linear31)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M210 163.9c-9 3.2-19.6 12.3-17.5 22.3 2.2 10 6 22.8 15 26.2 11.8 4.4 24-14.6 25.7-33.1 1-10.2-9-20.5-23.3-15.4z",
      "fill": "url(#_Radial32)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M139.1 137.7a24 24 0 00-17.8 5c-9.8 8-2.6 30.2-2.6 30.2s19 22.6 51.2 8.7c-2.5-14.7-4.4-42.1-30.8-43.9z",
      "fill": "url(#_Linear33)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M137.4 168.2c-8.6-2-23.4 4.2-23.1 13 .7 21 14.4 32.6 25.8 34.1 8.7 1.2 11-19.4 13-28 2-8.6-7.1-17-15.7-19z",
      "fill": "url(#_Radial34)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M221 173c-3.1.8-5.3 3-4.9 4.7.5 1.7 3.5 2.4 6.6 1.6 3.2-.9 5.4-3 5-4.7-.5-1.7-3.5-2.4-6.6-1.6z",
      "fill": "url(#_Linear35)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M125.6 174.8c-3.2-.5-6 .4-6.4 2.2-.3 1.7 2 3.6 5.3 4.2 3.2.6 6-.4 6.3-2.2.4-1.7-2-3.6-5.2-4.2z",
      "fill": "url(#_Linear36)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M190.6 76c-25.8-2.1-60 12.8-69.9 43.1-9.8 30.3-9.6 54.4-5.4 65.3 0 0-4.9-17.8 15.2-22.3 0 0-4.7-26.3 9-46.7 8.3-12.5 24.4-16.1 33.6-16.7 9.8-.7 19.1 1.1 27.3 9 11.6 11.3 17 31.3 15.4 54.2 14.9.1 17.5 13.6 17.2 22.7 0 0 6.4-28.2-3-58-6.2-19.5-13.7-48.3-39.4-50.5z",
      "fill": "url(#_Linear37)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M174.7 225c-4.8.2-8.8 2-8.7 4 0 1.8 4 3.2 8.8 3 4.9-.2 8.8-2 8.8-4 0-1.8-4-3.3-8.9-3z",
      "fill": "url(#_Linear38)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M133.1 211.3c-14.1-9.3-19.7-38-19.7-38a46 46 0 0018.2 40.7c8.6 5.6 19.3 15.2 23 18.3-3.9-3.6-8.6-12.6-21.5-21zM237.4 158.2c-1.8 0-3.9 4.8-3.9 4.8.6 17.4-2.9 27.9-2.9 27.9 10.4-3.4 17.3-32.9 6.8-32.7z",
      "fill": "#f0c999",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M236.1 173.8c1.3 6-1.3 9.5-1.3 9.5s3.6-4.7 4.1-8.6c1-7.6-2-8.1-.7-10 1.1-1.6 2.7 2.9 2.7 2.9 1.5-10.2-7.8-7.8-4.8 6.2z",
      "fill": "#dba779",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M227 166c6 11.6 5.5 30.3-10.4 44-11.7 10.1-15.4 15.7-19 19.8 5.6-4.9 15.6-13.9 20.4-17.8 8.3-6.6 17.7-18.2 15-34.4-.5-3.7-3-9.4-6-11.6z",
      "fill": "url(#_Linear39)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M156.9 234.2s17.7 18 36.7-1.2c0 0-18.1 13.1-36.7 1.2z",
      "fill": "#dba779",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M174.1 197.3c2-.3 10.3-5.8 10.3-5.8l-21.3.2s9 5.9 11 5.6z",
      "fill": "url(#_Linear40)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M173.7 182.7c-5.6.2-7.2 1.6-6.8 3.2 1 3.6 3.5 4.3 7 4.2 3.7 0 6.6-.8 7.2-4.8.1-1.2-1.7-2.8-7.4-2.6z",
      "fill": "url(#_Linear41)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M177.6 192.5s10.4.1 7-3.3c-1.1-1.1-7 3.3-7 3.3z",
      "fill": "url(#_Linear42)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M163.2 189.8c-3.5 3 7.4 2.8 7.4 2.8s-6.2-3.8-7.4-2.8z",
      "fill": "url(#_Linear43)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M173.9 191.2c-10.5-.1-11.8-5.2-13.2-2-.5 1.4.6 1.8 2.4 2.5 0 0-.6-1.5 1.8-1.4 1.7 0 3 3.7 9.1 3.5 6.5-.2 7.4-3.5 9-3.6h.3a1.2 1.2 0 011.1 1.3s3-1.6 1.9-3c-2.1-2.5-2.7 2.7-12.4 2.7z",
      "fill": "#f0c999",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M223.6 141c-10.8-6.9-19.5-4.5-19.5-4.5 25 2 20.1 25.6 20.1 25.6s5.7-17.1-.6-21.1z",
      "fill": "#f7d9ab",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M193.6 138c-4.3 2-7.4 7.8-3.7 6.5 3.8-1.2 17.7-6.5 20.8-6.6 4.7 0 11.7 2.4 13.5 3.6 0 0-8.4-6.6-13.6-7.1a46.3 46.3 0 00-17 3.6z",
      "fill": "url(#_Linear44)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M151.8 138.6c-2.4-1-12.7-4.2-17.9-3.4-5.2.8-13.3 7.8-13.3 7.8 1.8-1.2 9-4.3 13.4-4.2 3 0 17.2 4.6 21 5.7 3.8 1 1.2-4.1-3.3-6z",
      "fill": "url(#_Linear45)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M196.9 94.6c-27-10.3-50.3-1-56 4.5-14.3 13.3-19.8 26.3-23.4 52 0 0 11.2-29.2 14.6-34.2 3.3-5.1 8.8-13.9 19-18.1a63.5 63.5 0 0145.4.8c22 7.9 33.8 54 33.8 54s-6-48.6-33.4-59z",
      "fill": "url(#_Linear46)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M137.4 147.7c-4.3.4-13.5 1.9-13.4 10 0 10.3 10.8 12.8 15.6 12.9 6 0 10.2-1.7 13.8-2.8 1.8-.6 3.6-1 5.5-1.4-.4-7.9-3.6-18.6-21.5-18.7z",
      "fill": "url(#_Linear47)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M148 154c1.8 1.7 3.9 4.7 4 7.5.1 3.2-1 5-3.2 7 2.7-.8 5.3-2.1 9.2-2.7 0 0-3.7-8-10-11.8z",
      "fill": "url(#_Linear48)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M148.5 155.2c1.8 1.3 3 3.2 3.4 5.4a31 31 0 016.2 5.2c1.8 2-3.8-7.8-9.6-10.6z",
      "fill": "#ddd",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M140.6 152.3c-4.4.4-9.7 2.6-16.2 8 0 0 3.6 7.7 14 9-2.4-1.5-4.1-3.6-4.3-7a10 10 0 016.5-10z",
      "fill": "url(#_Linear49)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M151.9 160.4c-5.2-3.7-12-4.6-18-2.6-.7 1.5-1 3.1-1 4.7.2 3.3 2 5.3 4.6 6.9 4 .7 10.5-.6 11.3-1 2.2-1.9 3.4-3.8 3.2-7l-.1-1z",
      "fill": "url(#_Linear50)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M126 160.5l1.3 2.3c1.9-1.4 3.9-2.6 6-3.5a9 9 0 014.3-5c-4.6.8-9 3-11.5 6.2z",
      "fill": "#ddd",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M148.5 155.2c-.8-.4-1.6-.7-2.5-.9-2.7-.5-5.6-.5-8.4 0-2 1-3.6 2.9-4.3 5 3-1.3 6.4-1.8 9.8-1.6a21 21 0 018.8 3 8.6 8.6 0 00-3.4-5.5z",
      "fill": "url(#_Linear51)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M142 155c-3 .2-5.5 2.9-5.5 6 0 3.3 2.8 6 6.1 6a6.1 6.1 0 006.1-6.4c-.3-3.4-3.3-6-6.7-5.7z",
      "fill": "url(#_Radial52)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M144 158.4a1.6 1.6 0 00-2.3.8c-.4.8-.1 1.9.7 2.3a1.6 1.6 0 002.2-.8c.4-.8.1-1.8-.7-2.2zM149.4 160.8c-1.1-.6-2.5-.1-3 1a2.2 2.2 0 001 3c1 .5 2.4 0 3-1a2.2 2.2 0 00-1-3z",
      "fill": "#fff",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M131 152.6a12.5 12.5 0 01-10.6.3c0 .2-.8 6.5 3.8 8.1l.2.7c-1.2-.1-2.4.5-3 1.5-.7 1 1.8-1 6 2a22 22 0 0011.4 4.3c-6-2.4-9-3.8-12.2-8.7a23.4 23.4 0 0116.7-5.4c8.5.5 14.8 10.4 14.8 10.4-2.7-10.7-11.2-19.5-27.1-13.2z",
      "fill": "url(#_Linear53)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M146.8 148.7c-5.2-1.7-11-1.5-16 .4-5.3 2 9.3-1.8 15.7.7a26 26 0 018.8 5.1c-2-2.9-5-5-8.5-6.2z",
      "fill": "#dba779",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M144.4 154.5c-13.7-1.4-17.8 6.3-17.8 6.3 4.9-4 11.1-5.8 17.4-5.3 7.8.7 14 10.3 14 10.3s-3.3-10.2-13.6-11.3z",
      "fill": "url(#_Linear54)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M207.2 147.4c-17.9 0-21.2 10.6-21.6 18.5l5.4 1.5c3.6 1 7.8 2.9 13.9 2.8 4.7 0 15.5-2.4 15.7-12.6.1-8.2-9-9.8-13.4-10.2z",
      "fill": "url(#_Linear55)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M186.4 165.3c4 .6 6.5 2 9.2 2.7-2-2-3.3-3.7-3.1-7 .1-2.7 2.3-5.7 4-7.4a30.7 30.7 0 00-10.1 11.7z",
      "fill": "url(#_Linear56)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M186.4 165.3c1.9-2 4-3.7 6.3-5.1a8.8 8.8 0 013.4-5.4c-5.9 2.8-9.7 10.5-9.7 10.5z",
      "fill": "#ddd",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M210.4 162c-.2 3.4-2 5.5-4.4 7 10.4-1.2 14.1-9 14.1-9a30.5 30.5 0 00-16.1-8 10 10 0 016.4 10z",
      "fill": "url(#_Linear57)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M192.6 160l-.1 1.1c-.3 3.1 1 5 3.1 7 .8.3 7.3 1.7 11.3 1 2.6-1.5 4.4-3.5 4.6-6.8.1-1.6-.2-3.2-.9-4.7-6-2.1-12.7-1.2-18 2.4z",
      "fill": "url(#_Linear58)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M207 154a9 9 0 014.2 5c2.1 1 4.2 2.2 6 3.6l1.3-2.3A19.4 19.4 0 00207 154z",
      "fill": "#ddd",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M207 154c-2.8-.5-5.6-.6-8.4 0-.9 0-1.7.4-2.5.8a8.7 8.7 0 00-3.5 5.4 20.6 20.6 0 0118.6-1c-.6-2.3-2.2-4.1-4.2-5.2z",
      "fill": "url(#_Linear59)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M202.6 154.6a6 6 0 105.8 6.1c0-3.2-2.6-6-5.8-6.1z",
      "fill": "url(#_Radial60)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M203.3 158c-.8-.5-1.8-.2-2.3.6a1.6 1.6 0 00.6 2.3c.8.4 1.8.2 2.3-.6a1.6 1.6 0 00-.6-2.3zM208.7 160.4a2.2 2.2 0 10.8 3.1c.7-1 .3-2.4-.8-3z",
      "fill": "#fff",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M224.2 152.8a12.5 12.5 0 01-10.6-.4c-15.9-6.5-24.4 2.2-27.2 13 0 0 6.5-9.9 14.9-10.3 6-.4 12 1.6 16.6 5.5-3.1 5-6.1 6.3-12.2 8.6a22 22 0 0011.5-4.2c4.1-3 6-2 6-2-.7-1-1.8-1.6-3-1.5l.1-.7c4.6-1.5 3.9-7.8 4-8z",
      "fill": "url(#_Linear61)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M197.8 148.3a17.5 17.5 0 00-8.6 6.2c-2.1 2.9 2.6-2.7 9-5 6.3-2.4 15.7-.6 15.7-.6-5.1-2-10.8-2.2-16-.6z",
      "fill": "#dba779",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M200.2 154.2c-10.3 1-13.8 11.1-13.8 11.1s6.4-9.5 14.2-10.2c6.3-.4 12.5 1.6 17.3 5.5 5 4-4-7.7-17.8-6.4z",
      "fill": "url(#_Linear62)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M135 259s28.3 26 84.7.4l4.7 6.1-.4 74.4-3.2 7.6s-46.8 13.4-82.8 1.4-6-91-6-91l3 1z",
      "fill": "url(#_Linear63)",
      "fill-rule": "nonzero"
    }
  }), _c('ellipse', {
    attrs: {
      "cx": "174.8",
      "cy": "68.8",
      "rx": "30.8",
      "ry": "26.9",
      "fill": "url(#_Linear64)"
    }
  }), _c('ellipse', {
    attrs: {
      "cx": "174.8",
      "cy": "83.6",
      "rx": "34",
      "ry": "19.5",
      "fill": "#4f2a1f"
    }
  }), _c('path', {
    attrs: {
      "d": "M240.5 164.4c-17.9-40.5-53-34.4-63.8-69-19.2 40-58.2 20.2-67.4 68.9-18.7-38.1-13.9-95.5 64.8-95.4 82.5.1 83.3 63.4 66.4 95.5z",
      "fill": "url(#_Linear65)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M176 83.2c-18.7-7-39.5.1-47.8 15.2 8.3-9 21-16.3 47.6-15.4l.2.2z",
      "fill": "#4f2a1f",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M176 81c-7.7-9.3-21-9.4-30.4-1 7.3-4.1 16.5-6.2 30.3.8v.1zM177.6 83.2a32.1 32.1 0 0141.6 15.2C212 89.4 201 82 177.8 83l-.2.1z",
      "fill": "#4f2a1f",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M177.7 81c6.7-9.3 18.3-9.4 26.4-1-6.4-4.1-14.4-6.2-26.4.8v.1z",
      "fill": "#4f2a1f",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M194 206.6s-7.4 8.3-19 8.3c-9.3 0-19-8.3-19-8.3s13.3 1.6 18.8 1.6 19.2-1.6 19.2-1.6z",
      "fill": "#a01721",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M185.2 206a23 23 0 01-7.4-2.3c-.7.9-4.5.8-5 0-.8.6-5.3 1.9-8.5 2.4a49 49 0 01-8.3.5 97.4 97.4 0 0019 2.3c6.4-.2 12.7-1 19-2.3-3 0-5.9-.2-8.8-.6z",
      "fill": "#c73c3c",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M168.3 159c.3 10.6-10.4 19.1-23.2 20.7-13.7 1.7-27-4.4-31-14.3-.6-1.6-1.5-2.2-3.6-2-3 .3-2.7-1.2-2.7-2.6 0-1.5.3-2.6 2.7-2.3 2.4.2 2.2-.8 2.6-2 2.5-9.8 12-16.3 24-17.3 12.4-1.1 23 3.2 28.5 11.6.7 1 1.2 1.2 2.7.5 3.8-2 8.3-2 12.2-.1 2 1 2.4.4 3.3-.9 7-10.4 23.9-14.5 37.7-9 8.6 3.4 13.3 8.8 14.6 16 .2 1.4 1.5 1 2.3 1 2.2-.3 2.8.5 2.7 1.8 0 1.4.8 3.2-2.4 3.1-1.9 0-3.1.1-3.7 1.8-2.4 7.5-12.2 13.8-22.7 14.6-17.4 1.5-31.6-8-31.4-20.9 0-1.6.6-3.4-2.4-4.2-3.3-.8-6.5-.9-9.4.8-1.8 1-.6 2.5-.8 3.6zm63.3.4c.4-9.8-11-17.3-23.1-17.3-12.5.1-23.2 7.8-23.2 16.8 0 9.9 10.2 17.7 23.2 17.7 12.8 0 23-7.6 23-17.2zm-114-.7c-.6 10.5 10 17.8 22.6 18 11.6.1 23-5.7 23.5-16.8.6-10.5-10.5-17.3-22.4-17.6-12.6-.4-23.3 7-23.7 16.4z",
      "fill": "url(#_Linear66)",
      "fill-rule": "nonzero"
    }
  }), _c('path', {
    attrs: {
      "d": "M125.3 208.5c-1.7 7.5-6.2 13-11.5 13-6.7 0-12.1-8.8-12.1-19.7 0-10.6 5.2-19.2 11.7-19.6l.2-.9-1.2-.2c-8 0-14.5 10.5-14.5 23.4 0 13 6.5 23.4 14.5 23.4 7 0 12.8-8 14.2-18.5-.5-.2-1-.6-1.3-1zM236 181.1c-.8 0-1.6.2-2.3.4l.7.8h.4c6 0 10.9 8.7 10.9 19.6 0 10.8-4.9 19.6-11 19.6-4.7 0-8.8-5.7-10.3-13.5l-1.2.8c1.1 11 6.4 19.1 12.8 19.1 7.2 0 13-10.4 13-23.4 0-12.9-5.9-23.4-13-23.4z",
      "fill": "#a01721",
      "fill-rule": "nonzero"
    }
  }), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "_Linear1",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(43.25) rotate(84.8 -1 5)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#c32332"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#b30e21"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#a80016"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#a80016"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear2",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-76.35) rotate(87.8 .9 -3.2)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#c32332"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#c72837"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#d13846"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#d43c4a"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear3",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(109.2 46.5 167.8) scale(89.2)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f0c999"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f1cb9c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f4d3a4"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear4",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-25.26) rotate(52.8 6.7 -14.3)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#ffdeb3"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#fcdcb0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear5",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(5156.4 1980.1) scale(1782.13)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#ffdeb3"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#fcdcb0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear6",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-98.1 3647.8 854) scale(448.269)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f0c999"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f1cb9c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f4d3a4"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear7",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(98.2 4637.3 22887.4) scale(29866.55)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f0c999"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f1cb9c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f4d3a4"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear8",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(89.7 -6685.7 8915.7) scale(5829.6889)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f0c999"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f1cb9c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f4d3a4"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear9",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(89.6 -6243.3 7535.6) scale(4431.3964)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f0c999"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f1cb9c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f4d3a4"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear10",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-93.3 289 122.1) scale(105.58)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#f9f8fa"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f1f0f5"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear11",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(240.8 270.7) scale(59.42)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#d43c4a"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".1",
      "stop-color": "#d33a48"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#c72938"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#c32332"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear12",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-2000.24) rotate(-9.6 -12.4 14.6)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#d43c4a"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".1",
      "stop-color": "#d33a48"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#c72938"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#c32332"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear13",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(88.3 -3334.3 4038.7) scale(1217.48)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#d43c4a"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".1",
      "stop-color": "#d33a48"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#c72938"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#c32332"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear14",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(742.3848) rotate(89.6 -3 3.7)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#c32332"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#b30e21"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#a80016"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#a80016"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear15",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-85.9 251.8 100.2) scale(40.01)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#e1e1e5"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f1f0f5"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear16",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-89.1 8649.3 6248) scale(1597.651)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#e1e1e5"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f1f0f5"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear17",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(90 -7075.7 14201.2) scale(13243.7)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#c32332"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#b30e21"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#a80016"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#a80016"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear18",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(90 -8889.8 12170.7) scale(12970.7)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#c32332"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#b30e21"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#a80016"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#a80016"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear19",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(10690.503) rotate(-88.4 2.2 1.2)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#c32332"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#c72837"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#d13846"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#d43c4a"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear20",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(10789.79) rotate(-88.4 1.9 1.4)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#c32332"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#c72837"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#d13846"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#d43c4a"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear21",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(89.6 -1439.7 2643.4) scale(444.97)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#c32332"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#b30e21"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#a80016"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#a80016"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear22",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(88.4 -1304.9 4315.6) scale(601.2828)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#d43c4a"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".1",
      "stop-color": "#d33a48"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#c72938"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#c32332"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear23",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-160.9 125.2 101.4) scale(246.7)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f0c999"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#e4b586"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#dba779"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear24",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-9.62) rotate(39.6 21.8 -33.3)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f6d7a8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f3cfa0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear25",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-51.456) rotate(23.9 62 -109)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f6d7a8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f3cfa0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear26",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(158.3 208.6) scale(32.87)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#e8d8d7"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".1",
      "stop-color": "#f0e5e4"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#fbf8f8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#e8d2d1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear27",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(147.7 204.8) scale(51.72)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#e8d8d7"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#ebdedd"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".2",
      "stop-color": "#f6f0f0"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#fdfbfb"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#fbf8f8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#f1e4e3"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#e8d2d1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear28",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(157 210.6) scale(37.83)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f96e7e"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fa7080"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#fe7a86"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#ff7d88"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#fd7985"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f86d7d"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f86d7d"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear29",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(155.4 203.9) scale(40.04)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#e8d8d7"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".1",
      "stop-color": "#ebdcdb"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#f7efef"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#fbf6f6"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#e8d2d1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear30",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(4776.9 832.6) scale(821.574)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f96e7e"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fa7080"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#fe7a86"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#ff7d88"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#fd7985"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f86d7d"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f86d7d"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear31",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-1920.983) rotate(78.8 0 -5.8)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f6d7a8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f3cfa0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear33",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-2309.03) rotate(79.9 .7 -4)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f6d7a8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f3cfa0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear35",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(216.5 176.2) scale(11.61)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#ffdeb3"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear36",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(1505.1 1359.9) scale(135.98)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#ffdeb3"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear37",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-12582.324) rotate(88.7 0 -1.7)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f0c999"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f1cb9c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f4d3a4"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear38",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(2991 1840) scale(407.501)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#ffdeb3"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#fcdcb0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear39",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(7294.5 12785.5) scale(1289.47)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#ffdeb3"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#fcdcb0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear40",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-48.3477) rotate(88 -25.5 -55.3)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f7d9ab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f6d7a8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f3cfa0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear41",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-170.674) rotate(53.5 1.5 -20.2)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#ffdeb3"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear42",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(153.7 70.2 116.5) scale(7.91)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#dba779"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#e4b586"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear43",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(62.3569) rotate(8.3 -70.4 170)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#dba779"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#e4b586"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear44",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(188.3 139.5) scale(35.98)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#956134"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#81552c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#744e27"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#704b25"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear45",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(120.6 139.9) scale(36.23)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#704b25"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#744e27"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#81552c"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#956134"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear46",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-86.6 15082.4 -5549.4) scale(4545.258)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#dba779"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#e4b586"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear47",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-1048.655) rotate(-14.3 -16.6 19.3)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f0c999"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#e4b586"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#dba779"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear48",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(147.8 161.2) scale(10.06)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#fdfcfc"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f6f4f4"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#ece7e7"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear49",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(2225.2 2896.6) scale(137.15)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#fdfcfc"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f6f4f4"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#ece7e7"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear50",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-144.6 106.5 61.9) scale(29.73)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#ddddda"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#a4a59d"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear51",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-28.57) rotate(28.1 9.2 -15.4)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#c5c6c0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#94958d"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear53",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(12.5 -642 548.4) scale(56.66)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#422a16"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#462d18"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#53341c"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#674024"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear54",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(126.6 160) scale(31.49)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#674024"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#53341c"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#462d18"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#422a16"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#422a16"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear55",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-1207.458) rotate(-14.2 -15.3 24.6)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#dba779"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#e4b586"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f0c999"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear56",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(2081.7 2469.3) scale(103.531)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#fdfcfc"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f6f4f4"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#ece7e7"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear57",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(3583 2894.3) scale(135.912)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#fdfcfc"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#f6f4f4"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#ece7e7"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear58",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "rotate(-157.3 2374.8 734.7) scale(490.327)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#ddddda"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#a4a59d"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear59",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-572.819) rotate(2.4 46.6 -189.9)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#c5c6c0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#94958d"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear61",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-1367.398) rotate(-4.3 -33.6 81.9)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#422a16"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#462d18"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#53341c"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#674024"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear62",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(6316.5 1951.4) scale(1037.24)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#674024"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#53341c"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#462d18"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#422a16"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#422a16"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear63",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "scale(-208.43) rotate(84.4 1 -1.9)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#673024"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#53271c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#462118"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#421f16"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear64",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(61.6 0 0 61.6 144 68.8)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#622e20"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#673123"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#743a2c"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#7d4133"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear65",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(15027.4 11204.5) scale(22194.2)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#622e20"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#673123"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#743a2c"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#7d4133"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear66",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(17806.9 -8.62213 8.62213 17806.9 14487.8 6700.7)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#622e20"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#673123"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#743a2c"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#7d4133"
    }
  })], 1), _c('radialGradient', {
    attrs: {
      "id": "_Radial32",
      "cx": "0",
      "cy": "0",
      "r": "1",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(215.5 185.3) scale(22.92)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f9b58e"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#f8c89d"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('radialGradient', {
    attrs: {
      "id": "_Radial34",
      "cx": "0",
      "cy": "0",
      "r": "1",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(5311 9186.3) scale(1034.94)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f9b58e"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#f8c89d"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#f7d9ab"
    }
  })], 1), _c('radialGradient', {
    attrs: {
      "id": "_Radial52",
      "cx": "0",
      "cy": "0",
      "r": "1",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(7.26 0 0 7.26 140.6 161.7)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#2a3a3b"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#1c2727"
    }
  })], 1), _c('radialGradient', {
    attrs: {
      "id": "_Radial60",
      "cx": "0",
      "cy": "0",
      "r": "1",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "translate(2639 2123) scale(88.572)"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#2a3a3b"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#1c2727"
    }
  })], 1)], 1)] : [_c('g', {
    attrs: {
      "id": "Слой_2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Слой_1-2"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#b7b7b7"
    },
    attrs: {
      "d": "M51.698,51.702c68.89,-68.89 180.748,-68.89 249.637,-0c68.89,68.889 68.89,180.747 0,249.636c-68.889,68.89 -180.747,68.89 -249.637,0c-68.889,-68.889 -68.889,-180.747 0,-249.636Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear1)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M144,235.87c0,0 23.29,25.81 28.77,27.35c5.48,1.54 46.55,-26.89 47.65,-41.37l0.85,-25.58l-78.95,13.53l1.68,26.07Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear2)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M182.87,249.8c-3.08,0.6 -14.61,-0.46 -15.68,-0.36c-1.07,0.1 -18.39,-13.59 -18.49,-14.44c-0.1,-0.85 -5.35,-14.79 -5.35,-14.79c0,0 -0.3,13.43 1.31,16.49c1.61,3.06 20.7,16.6 20.7,16.6l14.46,2c0,0 21.41,-6.7 26.55,-12c4.9,-5 13,-30.06 13.68,-32.3c-2.083,5.744 -5.027,11.139 -8.73,16c-3.84,5.23 -27.91,22.7 -28.45,22.8Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear3)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M220.05,211c0.016,-0.061 0.036,-0.121 0.06,-0.18c-0.024,0.059 -0.044,0.119 -0.06,0.18Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f0eff3",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M195.86,260.15l-38.86,-1.95c0,0 -51.39,10.14 -51.57,12.15l-9.77,63.1c46.369,23.846 100.984,26.018 149.1,5.93l-3,-101.26l-45.9,22.03Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#909090",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M59.13,267.29c0.053,-1.063 0.29,-2.108 0.7,-3.09c-3.77,-1.46 -10.23,12.58 -11.11,34.08c4.11,4.32 8.45,8.42 13,12.31c-1.99,-26.16 -4.28,-39.43 -2.59,-43.3Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#909090",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M59.85,264.17c-3.13,6.42 -3.29,23 -2.39,42.67c1.83,1.68 3.71,3.31 5.61,4.91c-3.83,-29.49 -3.22,-47.58 -3.22,-47.58Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear4)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M231.8,299.64c-17.54,-28.18 -111.13,-24.39 -124.88,-14.83c-9.21,6.4 -21.24,22.42 -28.21,38.67c48.801,32.44 110.666,38.578 164.89,16.36c0.16,-13.29 -4.46,-28.4 -11.8,-40.2Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear5)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M137.84,253.56l-2.17,-16.68l-29,70.86l-3,29.62c3.94,1.78 7.94,3.423 12,4.93c1.32,-10 2.3,-17.23 2.58,-19c7.61,-48.79 19.59,-69.73 19.59,-69.73Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear6)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M177.42,286.55c0.12,-0.64 3.59,-2.52 6.59,-7.2c3,-4.68 4.67,-12.35 4.67,-12.35l-3.18,-6.55c-19.66,19.67 -13.14,39.81 -13.28,49l-7.67,43.15c3.07,0.21 6.16,0.33 9.27,0.38c0.17,-2.15 0.34,-3.88 0.49,-5c1.31,-9.72 2.19,-56.6 3.11,-61.43Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear7)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M222.17,232.82c-0,0 -7,73 -8.51,76.48c-0.58,1.33 -3.1,18.85 -5.8,41c10.274,-1.862 20.361,-4.64 30.14,-8.3l-3.25,-106.15l-12.58,-3.03Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#909090",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M310,292l1.34,-31.77c0,0 -52.44,-13.13 -58.16,-17.16c-5.72,-4.03 -31,-14.5 -31,-14.5c0,0 5.77,12.93 6.1,20.86c0.3,7.11 -4.85,71.21 -7.67,98.06c34.741,-8.977 65.931,-28.339 89.39,-55.49Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear8)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M171.87,256.88l-29.55,-15.43l-11.08,5.38c0.68,27 3.26,38 3.26,38c1.2,-0.51 31.45,-25.7 31.45,-25.7l9.35,1.08c0,0 17.54,23.94 23.18,31.66c9.79,-9.43 33.56,-49.37 33.56,-49.37l-47.1,16.24l-13.07,-1.86Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#909090",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M121.89,274.28c5.54,-14.48 2.47,-34.64 2.47,-34.64c-32.31,13.29 -52.93,20.51 -64.53,24.56c-1.63,15.83 -1,29.18 0.83,45.49c13.128,11.442 27.878,20.878 43.77,28c0.7,-4.95 1.13,-8.11 1.19,-8.75c0.47,-4.63 13.11,-46.41 16.27,-54.66Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#909090",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M138.89,236.57l-0.77,-6.18l-42.53,22.05l16.94,6.9l-22.68,2.81c0,0 3.44,52.39 3.75,70.21c5.33,2.849 10.804,5.419 16.4,7.7c0.45,-3.13 0.86,-5.94 1.23,-8.36c11.77,-67.6 27.66,-95.13 27.66,-95.13Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#909090",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M157.49,280.25c0,0 -14.84,47.59 -19.91,68.48c10.28,2.304 20.745,3.689 31.27,4.14c1.39,-17.34 6.43,-73.81 6.43,-73.81l-17.79,1.19Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#909090",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M156.65,283c14.31,2.67 17.78,5.69 17.78,5.69l0.85,-8.62l-17.55,-1.21l-1.08,4.14Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#909090",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M170.94,254.66c-2.357,-0.466 -4.783,-0.466 -7.14,0c-2.099,1.478 -4.386,2.669 -6.8,3.54c-2.414,0.871 -4.63,14.18 0.42,22.6c5.43,0.57 11.32,1.8 17.31,2.17c9.75,-5.21 11.55,-18 11.55,-18l-7.67,-9.17c0,0 -3.77,-0.37 -7.67,-1.14Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#909090",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M253.74,258.84l13.71,-8.65c0,-0 -25,-14.24 -38.75,-21.61c0,-0 -4.45,37.8 -4.45,41.92c0,2.76 -4.12,46.78 -7.17,77.86c8.705,-2.05 17.24,-4.764 25.53,-8.12c10.34,-29.55 29,-79.34 29,-79.34l-17.87,-2.06Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#909090",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M166.07,253.56l-8.19,0c0,0 -2.71,8.27 -2.63,13.09c0.55,-0.66 12,-11.39 12,-11.39l8.4,1.09l9.14,14c0.862,-2.305 1.56,-4.667 2.09,-7.07c-1.71,-2.3 -7.06,-8 -7.06,-8l-13.75,-1.72Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f0eff3",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M212,228.72c-4.31,4.85 -21,22.68 -32.19,26.54c0,0 17.84,25.94 20.12,29.55l16,-21.53c0,0 14.19,-21.94 14.18,-30.46c0,-9.15 -9.28,-24 -9.28,-24c0,0 -4.5,15.06 -8.83,19.9Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f0eff3",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M143.35,220.16c0,0 -7.42,9.58 -7.68,16.72c-0.24,6.16 -0.44,42.56 -0.44,42.56c0,0 18.82,-23.12 30.84,-25.88c0,0 -10.84,-7.62 -15.65,-12.61c-4.81,-4.99 -7.07,-20.79 -7.07,-20.79Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear9)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M149.55,239.72c-0.76,-1.69 -5,-10.2 -5.7,-18.25c0,0 -2.89,14.15 2.71,20c5.6,5.85 17.64,11.31 19.51,12.11c-0,-0.02 -15.76,-12.18 -16.52,-13.86Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear10)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M197.18,243.54c-10,9.28 -17.36,11.72 -17.36,11.72c0,0 3,0.82 18.12,-8.43c3.55,-2.17 15.42,-14.12 18,-17.09c2.58,-2.97 4.9,-20.93 4.9,-20.93c0,0 -5.84,15.13 -6.84,17.12c-1,1.99 -9.57,10.88 -16.82,17.61Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear11)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M186.56,265.08l13.38,19.73l12.72,-17.14c-9.79,4.79 -26.1,-2.59 -26.1,-2.59Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear12)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M135.46,249.44l-0.23,30c1.49,-1.13 13.47,-14.36 13.47,-14.36c-11.35,-3.62 -13.24,-15.64 -13.24,-15.64Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#909090",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M306.16,296.31l5.2,-35.72c-13.55,13.11 -17.94,28.5 -24.83,54c6.995,-5.59 13.557,-11.701 19.63,-18.28Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#909090",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M319.68,279.8c-3.1,-11.55 -6.42,-21.38 -8.83,-19.39c-8.17,6.74 -14.64,28.43 -19.39,50.08c10.582,-9.083 20.054,-19.385 28.22,-30.69Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#909090",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M317.16,271.07c-1.029,4.902 -1.734,9.866 -2.11,14.86c1.567,-2 3.097,-4.023 4.59,-6.07c-1.5,-5.34 -2.48,-8.79 -2.48,-8.79Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f0c999",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M104.89,137.2c-7.48,1.39 -5.84,6.48 -2.57,15.41c3.18,23.71 9.28,28.45 11.88,27c4.73,-2.61 -0.2,-44.08 -9.31,-42.41Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear13)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M110.94,171c0,0 -3.5,-4.44 -2.1,-12.77c3.3,-19.66 -8.76,-21.62 -6.45,-8c0,0 1.89,-6.29 3.35,-4.31c1.81,2.43 -2.13,3.53 -0.48,13.84c0.87,5.35 5.68,11.24 5.68,11.24Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f0c999",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M245.82,137c7.55,1 6.2,6.2 3.44,15.26c-1.81,23.83 -7.63,28.84 -10.31,27.52c-4.87,-2.39 -2.27,-44 6.87,-42.78Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear14)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M241.71,171c0,0 3.24,-4.6 1.37,-12.86c-4.42,-19.48 7.5,-22 6,-8.26c0,0 -2.24,-6.18 -3.6,-4.14c-1.66,2.51 2.33,3.43 1.28,13.8c-0.58,5.46 -5.05,11.46 -5.05,11.46Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f7d9ab",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M239.94,135.86c2.23,-55.79 -14.88,-63.31 -19.75,-69c-9.93,-11.57 -25.52,-16.62 -52.18,-16c0,0 -34.73,1.22 -43.41,20.24c-9.29,20.34 -10.95,48.3 -10.13,74.52c1,31.83 1,40.26 3.76,46.92c1.755,4.879 4.911,9.134 9.07,12.23c9.88,7.81 22.88,22.51 30.88,28.94c3.23,2.59 24.82,8.12 41.8,-3.39c8.9,-6 18.16,-13.68 29,-24.52c4.8,-4.8 7.9,-12.59 7.9,-16.49c0,-4.47 2.66,-21.39 2.5,-24.71c-0.89,-17.97 -0.06,-13.23 0.56,-28.74Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Radial15)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M212.82,188.61c11,0.74 24.28,-0.66 26.58,-23.43c1.31,-13 -1.13,-19.74 -6.55,-20.75c-11.52,-2.16 -28,2.89 -34.91,6.48c-14.53,7.58 -4.56,36.39 14.88,37.7Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Radial16)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M152.11,149.82c-3.13,-1.15 -27,-6.6 -34.13,-4.52c-4.06,1.19 -5.39,10.37 -4.71,19c0.32,4.16 1.25,10.79 2.19,13.4c4.59,12.84 24.17,13.4 34.28,9.82c17.26,-6.06 18.26,-31.89 2.37,-37.7Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear17)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M231.55,150.65c-2,-1.11 -3.45,0.5 -7.56,1.86c-4.11,1.36 -15.06,3.41 -9.88,6.23c5.72,3.11 13.73,-1.16 14.7,-2c0.97,-0.84 5.19,-4.74 2.74,-6.09Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear18)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M200.86,195l-1,0.89c0.354,-0.272 0.689,-0.57 1,-0.89Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear19)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M196.59,177.43c11,8.93 6.56,15.33 4.27,17.58c4.25,-3.56 10,-7.53 9.59,-9.09c-1.36,-5.68 -13.86,-8.49 -13.86,-8.49Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#e1b58c",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M199.72,188.3c0,0 5.66,-1.31 6.16,-1.72c0.451,-0.542 0.791,-1.167 1,-1.84l-3.6,1.09l-3.56,2.47Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear20)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M145.55,186.78c0.25,1.75 5.18,6 8.42,9.39c0,0 -8.64,-9.28 3.37,-17.65c0,0 -12.63,2.4 -11.79,8.26Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#e1b58c",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M148.5,185.1c0.194,0.672 0.516,1.301 0.95,1.85c0.5,0.4 6.16,1.71 6.16,1.71l-3.52,-2.47l-3.59,-1.09Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear21)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M166.2,209.77c15,-1.66 25.13,0.19 25.13,0.19c-11.33,-7.07 -25.13,-0.19 -25.13,-0.19Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#96282d",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M149.84,185.8c0.31,0.32 0.53,0.75 0.92,0.93c7.2,3.19 7.3,6.23 10.39,7.9c10.94,5.9 23.71,4.47 32.3,-0.28c4.94,-2.72 5.57,-5.9 11.49,-8.21c0.44,-0.141 0.789,-0.483 0.94,-0.92c-31.59,7.72 -56.04,0.58 -56.04,0.58Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#fdddb3",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M178.15,200.85c-4.26,0 -8.47,-0.84 -8.47,0c0,0.84 3.7,2.68 8,2.68c4.3,0 8.47,-1.85 8.47,-2.68c0,-0.83 -3.74,0 -8,0Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear22)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M190.45,192.38c-4.391,0.975 -8.864,1.535 -13.36,1.67c-4.753,-0.102 -9.489,-0.624 -14.15,-1.56c-1.34,-0.24 -1.91,2.09 -1.91,2.09c4,2.93 8.85,4 16.56,4.09c10.32,0.07 16,-4.39 16,-4.39c-0,0 -1.45,-2.28 -3.14,-1.9Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear23)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M162.41,201.92c16.45,13.09 32.2,-0.89 32.2,-0.89c-16.61,8.85 -32.2,0.89 -32.2,0.89Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear24)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M157,187.31c0.158,1.724 1.256,3.226 2.85,3.9c1.6,0.68 5.17,3.4 19.07,3c13.9,-0.4 16.65,-3.78 17.28,-4.37c0.793,-0.834 1.382,-1.84 1.72,-2.94c0.338,-1.1 -20.92,4.1 -40.92,0.41Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f3eceb",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M156.94,187.06c0.05,0.679 0.234,1.342 0.54,1.95c0.39,0.61 11.49,2.23 19.88,2.28c8.39,0.05 19.33,-2.11 19.71,-2.59c0.434,-0.636 0.752,-1.343 0.94,-2.09c0.188,-0.747 -9.44,3.17 -41.07,0.45Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear25)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M148.12,185c0,0 2,1.17 1.72,0.85c0,0 24.45,7.14 56,-0.58l1.72,-0.86c-17.12,2.81 -59.44,0.59 -59.44,0.59Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear26)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M127.14,153c-4.17,-1.14 -5.73,-2.67 -7.65,-1.46c-2.36,1.5 2.05,5.23 3.06,6c1.01,0.77 9.22,4.6 14.77,1.2c5.03,-3.13 -6.08,-4.65 -10.18,-5.74Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear27)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M190.32,122.73c-0.84,5.43 -5.84,25.41 -2.65,27.29c19.9,11.73 41.68,-3.12 41.68,-3.12c5.53,-32.66 -39.03,-24.17 -39.03,-24.17Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear28)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M122.87,147.38c0,0 21.13,14.13 41.49,1c3.11,-2 -3,-19.75 -3.89,-25.18c-0,0.04 -38.07,-11.2 -37.6,24.18Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear29)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M145.16,132.52c-3.33,-0.18 -10.43,0.83 -12.81,2.68c-4.24,3.29 -5.74,6.27 -5.37,10.05c0.11,1.11 4.64,5.38 14.28,6.12c7.22,0.55 18.68,0 21.45,-3c1.33,-1.45 -0.38,-7.25 -0.93,-9.3c-1.01,-3.89 -6.48,-5.99 -16.62,-6.55Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear30)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M152.24,136.53c-15.47,-1.86 -14.54,0.44 -20.81,7.62c0.134,0.864 0.459,1.687 0.95,2.41c1.632,1.977 3.922,3.302 6.45,3.73c9.93,1.88 13.1,0.49 17.33,-0.37c1.81,-0.36 3.81,-2.08 3.76,-2.85c0.142,-2.051 -0.201,-4.106 -1,-6c-0.92,-2.18 -2.92,-4.07 -6.68,-4.54Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ddd",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M131.43,144.15c0.118,0.827 0.423,1.617 0.89,2.31c11.12,-6.88 23.11,-5.29 26.64,-5.4c-6.28,-4 -15.48,-3.11 -20,-3.61c-5.79,-0.63 -7.53,6.7 -7.53,6.7Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear31)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M146,137.41c-5,0.25 -9.22,4.16 -8.61,9.12c0.068,1.381 0.588,2.703 1.48,3.76c2.374,0.585 4.806,0.9 7.25,0.94c2.591,0.106 5.183,-0.156 7.7,-0.78c0.787,-1.312 1.266,-2.786 1.4,-4.31c0.26,-5.14 -3.22,-9.03 -9.22,-8.73Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear32)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M145.58,136.76c-3.954,0.312 -7.256,3.203 -8.09,7.08c-0.834,3.877 6,-2.89 16.44,-2.86c0,0.02 -2.93,-4.66 -8.35,-4.22Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Radial33)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M146.12,138.85c-2.822,0.118 -5.079,2.471 -5.079,5.295c-0,2.908 2.392,5.3 5.3,5.3c2.907,0 5.3,-2.392 5.3,-5.3c-0,-0.031 -0,-0.063 -0.001,-0.095c-0.103,-2.934 -2.585,-5.273 -5.52,-5.2Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear34)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M155.8,137.42c-5.46,-3 -14,-2.47 -19.42,-0.26c-2.983,1.014 -4.988,3.85 -4.95,7c0.038,3.15 2.8,-3.17 11.94,-4.42c5.241,-0.808 10.599,-0.356 15.63,1.32c-0.686,-1.501 -1.799,-2.768 -3.2,-3.64Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#fff",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M150.58,144.56c-1.127,0.518 -1.635,1.867 -1.13,3c0.607,1.098 2.003,1.511 3.11,0.92c1.132,-0.514 1.641,-1.867 1.13,-3c-0.603,-1.102 -2.004,-1.517 -3.11,-0.92Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#fff",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M145.72,142.32c-0.64,0.286 -1.053,0.924 -1.053,1.625c-0,0.257 0.055,0.511 0.163,0.745c0.484,0.87 1.591,1.197 2.47,0.73c0.637,-0.284 1.049,-0.919 1.049,-1.616c-0,-0.261 -0.058,-0.518 -0.169,-0.754c-0.48,-0.868 -1.584,-1.196 -2.46,-0.73Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear35)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M219.26,135.2c-2.38,-1.85 -9.48,-2.86 -12.81,-2.68c-10.13,0.56 -15.61,2.66 -16.62,6.54c-0.54,2.05 -2.26,7.85 -0.92,9.3c2.77,3 14.23,3.56 21.44,3c9.64,-0.74 14.17,-5 14.28,-6.12c0.37,-3.77 -1.13,-6.75 -5.37,-10.04Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear36)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M199.37,136.53c-3.78,0.45 -5.72,2.36 -6.71,4.53c-0.803,1.893 -1.146,3.949 -1,6c0,0.77 1.95,2.49 3.76,2.85c4.23,0.86 7.4,2.25 17.34,0.37c2.524,-0.43 4.811,-1.755 6.44,-3.73c0.509,-0.719 0.851,-1.542 1,-2.41c-6.29,-7.14 -5.35,-9.47 -20.83,-7.61Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ddd",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M212.67,137.45c-4.53,0.5 -13.74,-0.4 -20,3.61c3.52,0.11 15.52,-1.48 26.63,5.4c0.472,-0.69 0.777,-1.481 0.89,-2.31c0.113,-0.829 -1.74,-7.33 -7.52,-6.7Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear37)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M205.65,137.41c-6,-0.3 -9.52,3.62 -9.22,8.73c0.139,1.523 0.617,2.996 1.4,4.31c2.517,0.624 5.109,0.886 7.7,0.78c2.448,-0.04 4.883,-0.356 7.26,-0.94c0.89,-1.058 1.406,-2.379 1.47,-3.76c0.61,-4.96 -3.57,-8.87 -8.61,-9.12Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear38)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M206,136.76c-5.42,-0.44 -8.34,4.22 -8.34,4.22c10.43,0 16.43,2.86 16.43,2.86c-0.834,-3.877 -4.136,-6.768 -8.09,-7.08Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Radial39)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M205.49,138.85c-2.884,0.033 -5.239,2.415 -5.239,5.3c-0,2.907 2.392,5.3 5.3,5.3c2.873,-0 5.25,-2.337 5.299,-5.21c0,-0.017 0,-0.033 0,-0.05c0,-2.929 -2.41,-5.34 -5.34,-5.34c-0.007,-0 -0.013,-0 -0.02,0Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear40)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M215.23,137.16c-5.45,-2.21 -14,-2.79 -19.41,0.26c-1.386,0.878 -2.485,2.144 -3.16,3.64c5.014,-1.674 10.355,-2.13 15.58,-1.33c9.15,1.25 11.94,4.42 11.94,4.42c0.034,-3.147 -1.971,-5.977 -4.95,-6.99Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#fff",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M209.94,144.32c-1.287,0.17 -2.212,1.36 -2.06,2.65c0.115,1.183 1.121,2.096 2.309,2.096c0.091,-0 0.181,-0.005 0.271,-0.016c1.292,-0.17 2.218,-1.367 2.06,-2.66c-0.119,-1.179 -1.124,-2.086 -2.308,-2.086c-0.091,0 -0.182,0.005 -0.272,0.016Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#fff",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M204.84,142.13c-0.979,0.07 -1.746,0.894 -1.746,1.875c-0,1.032 0.848,1.88 1.88,1.88c1.031,0 1.88,-0.848 1.88,-1.88c-0,-0.075 -0.005,-0.15 -0.014,-0.225c-0.119,-0.989 -1.006,-1.721 -2,-1.65Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#eeb873",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M218.15,122.72c-11.92,-3.64 -17,-3.28 -26.11,-1.76c-3.11,0.52 -2.76,5.81 0.66,6.17c6.43,0.68 29.57,-2.34 29.57,-2.34c0,0 1.52,-0.35 -4.12,-2.07Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#eeb873",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M158.84,121c-9.08,-1.52 -14.18,-1.88 -26.1,1.76c-5.65,1.72 -4.13,2.07 -4.13,2.07c0,0 23.14,3 29.57,2.34c3.42,-0.4 3.82,-5.69 0.66,-6.17Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear41)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M112.51,160.12c0.46,12.26 2.44,24.41 4.08,30.22c1.343,5.155 4.088,9.839 7.93,13.53c9.63,9 22.61,19.55 22.61,19.55c-1.89,-2.76 -17.9,-21.19 -20.76,-25.47c-10.88,-16.28 -13.86,-37.83 -13.86,-37.83Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear42)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M206.79,225.43c4.07,-3.19 14,-11.37 22.49,-19.43c4,-3.83 6.58,-10.59 7.72,-15.05c1.14,-4.46 2.71,-30.17 2.71,-30.17c-1.22,11.16 -4.51,27.05 -10.43,37.7c-5.92,10.65 -20.16,23.86 -22.49,26.95Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear43)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M223.25,76.05c-24.38,-17.09 -89.65,-0.27 -96.32,-0.11c-6.67,0.16 -13.45,84.68 -13.45,84.68c0,0 6.53,-17.94 8.92,-28.05c2.39,-10.11 3.38,-34.12 12,-42.54c24.87,-24.39 69,-14 79.67,-4.23c11.41,10.5 13.47,36.87 15.78,43.07c2.31,6.2 8.9,28.23 8.9,28.23c0,0 8.88,-63.96 -15.5,-81.05Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#aaa",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M231,64.8c0,0 4.65,-13.69 -5.8,-22.94c0,0 3.48,3.47 0,9.25c0,0 -11.19,-23.9 -45.3,-25.13l6.69,7.62c0,0 -31.42,-12.1 -58.95,4.79c0,0 5.16,2.46 8.13,5.78c-17,-1.17 -25.87,8.92 -30.29,19.56c0,0 10.51,-5.94 19.83,1.07c0,0 -18.82,-3.74 -25.55,15.9c0,0 11.15,-11.25 18.58,0c0,0 -12.76,-1.58 -19,20.39c5.22,-8.11 9.09,-3.48 9.09,-3.48c0,0 -6.4,12.59 -2,39.8c0,0 6,2.06 6.74,18.72c0,0 6.32,-64.63 18.17,-72.48c30.07,-19.9 77.06,-10.23 83.95,-5.29c21.79,15.63 24.33,78.09 24.33,78.09c-0,0 -0.14,-20 6.89,-19.29c0.09,0 16.03,-57.87 -15.51,-72.36Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#aaa",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M231,64.8c0,0 5.68,-13.33 -5.8,-22.94c0,0 11.27,15.34 1,24.91c0,0 15.28,4.31 23.87,29.76c0.05,0 -0.25,-24.72 -19.07,-31.73Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#aaa",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M179.93,26l6.69,7.62l0,-3.13c0,0 13.56,-3.62 38.61,20.62c-0,0 -9.62,-23.87 -45.3,-25.11Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#aaa",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M127.67,38.39c3.054,1.39 5.814,3.352 8.13,5.78l-0.68,-5.63c37.09,-16.87 63.38,5.39 63.38,5.39c-15.79,-25.54 -69.8,-11.68 -70.83,-5.54Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#aaa",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M105.51,63.73c0,-0 4.89,-2 6.8,-2.15c0,-0 2.49,-16.32 23.49,-17.41c0,0 -20.59,-3.9 -30.29,19.56Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear44)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M133.74,184.36c-10.35,-2.92 -16.18,-40.52 -16.18,-40.52c-5.17,12.79 9.88,53.32 18.52,52.06c8.64,-1.26 18.52,-19.65 18.52,-19.65c0,0 -11.92,10.63 -20.86,8.11Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#aaa",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M99.79,80.7c1.458,-1.212 2.991,-2.331 4.59,-3.35c1.599,-1.019 4.38,-13.77 21,-12.55c-0.04,-0 -19.09,-4.19 -25.59,15.9Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear45)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M194.61,210c-4.05,3.33 -20.74,7.56 -32.2,1.19c-9.29,-5.17 -13.18,-22.85 -13.18,-22.85c0.12,13.07 3.78,22.72 8.11,28.39c4.33,5.67 29.82,5.17 41.53,-2.47c11.71,-7.64 8,-27.55 8,-27.55c0.13,6.29 -5.31,17.54 -12.26,23.29Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear46)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M224.16,181.29c-8.67,4.53 -21.11,-2.77 -21.11,-2.77c0,0 14.09,27.33 24.42,14.58c10.33,-12.75 7.24,-55 7.24,-55c0,0 -1.89,38.65 -10.55,43.19Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#aaa",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M99.41,101.09c0,0 2.69,-4 6.1,-4.79c0,0 -0.61,-11 12.86,-15.6c0,0 -14.19,-1.61 -18.96,20.39Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear47)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M150.49,47.77c-0.102,-0.027 -0.205,-0.047 -0.31,-0.06c0.104,0.014 0.208,0.034 0.31,0.06Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#aaa",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M197.53,47.71c0,0 15,14.44 15.35,25.88c-7.47,-4.8 -28,-5.27 -32.15,-5.2c-4,-5.4 -12.72,-17.53 -30.24,-20.62c2,0.48 9.52,2.62 19.67,20.07c-7,-0.56 -19.92,4 -22.68,4.59c-1.92,-1.38 -10.29,-5.77 -16,-5.74c0,0 8.91,4.11 9.74,7.8c0,0 -9.44,3.9 -14.24,12c-13.83,23.35 -13.8,75.41 -13.8,75.41c0,0 4.82,-18.53 7.33,-31.9c2.92,-15.46 3.87,-33.84 9.31,-41.18c13.83,-18.64 64.52,-22.12 85.56,-8.06c11.64,7.78 13.55,27.87 16.92,45.31c2.89,15 7.41,36.07 7.41,36.07c0,0 0.61,-59.21 -13.46,-79.87c0,0.04 -8.73,-24.99 -28.72,-34.56Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear48)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M182.41,150.6c0.64,-12.5 -3.74,-14.29 -7,-14.18c-3.26,0.11 -4.89,4.44 -4.25,14c0.64,9.56 -1.22,13.13 -0.8,17.57c0.2,2 1.14,3.35 6.27,3.39c5.63,0 7.59,-1.29 7.83,-3.18c0.69,-5.2 -2.46,-8.6 -2.05,-17.6Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#e1b58c",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M183,174.88c7.61,-1.88 10.61,-0.76 10.61,-0.76c-4.4,-3.89 -10.61,0.76 -10.61,0.76Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#e1b58c",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M161.46,173.56c0,0 3.95,-0.63 9.93,1.39c-0,0.05 -5.84,-4.42 -9.93,-1.39Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear49)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M188.93,162.22c-0.05,3.12 0.67,5.21 -0.28,7c-2.12,4 -7.6,5.54 -11.27,5.24c-2.78,0.33 -9.29,-1.06 -12,-5.21c-1.11,-1.7 -0.41,-3.22 -0.91,-6.54c0,0 -7.54,9.1 -3,10.86c0,0 1.32,-1 5,-0.66c3.68,0.34 2.9,4.33 11.26,4.41c7.29,0.07 5,-3.42 9.61,-4.09c4.61,-0.67 5.23,0.54 6.28,1c2.27,-0.01 0.6,-7.71 -4.69,-12.01Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "url(#_Linear50)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M169.59,167.56c-0.32,2 2.55,4.23 7.67,4.27c5.64,0 6.9,-2.19 6.43,-4.06c-2.78,-11.08 -12.91,-7.77 -14.1,-0.21Z"
    }
  })])]), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "_Linear1",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-12.07,-49.44,49.44,-12.07,199.09,283.63)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#daa679",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#e3b485",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.47"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0c998",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear2",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-79.791,-828.41,828.41,-79.791,14246.4,11590.8)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#daa679",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#e3b485",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.47"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0c998",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear3",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(8.81746e-19,-0.0144,0.0144,8.81746e-19,233.255,248.8)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#daa679",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#e3b485",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.47"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0c998",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear4",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(10.09,92.29,-92.29,10.09,150.98,236.6)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#fff",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f8f7f9",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.39"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0eff3",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear5",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(15.4,5.27,-5.27,15.4,113.92,285.56)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f0eff3",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#e0e0e4",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear6",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(24.13,0,0,24.13,164.55,306.73)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#e0e0e4",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0eff3",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear7",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(909.625,0,0,909.625,6472.76,34482.9)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#e0e0e4",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0eff3",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear8",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(250.992,-4573.6,4573.6,250.992,18297.4,15194)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#e0e0e4",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0eff3",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear9",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(259.511,-1878.43,1878.43,259.511,3639.61,8298.42)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#e0e0e4",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0eff3",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear10",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(1375.81,1060.41,-1060.41,1375.81,8372.74,10972.8)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#e0e0e4",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0eff3",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear11",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(19.05,-25.81,25.81,19.05,190.92,278.15)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f0eff3",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f8f7f9",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.61"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#fff",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear12",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-313.447,-1151.7,1151.7,-313.447,2087.98,8566.04)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f0eff3",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f8f7f9",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.61"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#fff",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear13",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(7.602,34.6693,-34.6693,7.602,107.285,138.095)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#dba779",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#e4b586",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.48"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0c999",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear14",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-41.0182,1049.98,-1049.98,-41.0182,2197.89,4264.38)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#dba779",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#e4b586",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.48"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0c999",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('radialGradient', {
    attrs: {
      "id": "_Radial15",
      "cx": "0",
      "cy": "0",
      "r": "1",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-31.75,1.27,1.5875,22.5425,227.502,157.916)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f8c79c",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('radialGradient', {
    attrs: {
      "id": "_Radial16",
      "cx": "0",
      "cy": "0",
      "r": "1",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(1658.48,-88.2306,168.344,1144.35,7097.3,7392.66)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f8c79c",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear17",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-19.04,6.56,-6.56,-19.04,232.12,152.78)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#fbdbaf",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear18",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-0.03,-2.21,2.21,-0.03,200.37,197.19)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f6d7a8",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.53"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f3cfa0",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.87"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f1ca9a",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear19",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-10.2718,-789.166,789.166,-10.2718,3030.76,4069.99)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f6d7a8",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.53"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f3cfa0",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.87"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f1ca9a",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear20",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-8.87259,-810.665,810.665,-8.87259,1944.87,4122.06)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f6d7a8",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.53"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f3cfa0",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.87"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f1ca9a",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear21",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-27.1404,-99.6301,99.6301,-27.1404,4678.54,949.764)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f6d7a8",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.53"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f3cfa0",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.87"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f1ca9a",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear22",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(39.1,0.67,-0.67,39.1,159.02,195.08)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#e8d9d7",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0e6e4",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.14"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#fbf8f8",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.39"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#fff",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.57"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#e8d3d1",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear23",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-33.81,-196.516,196.516,-33.81,5944.56,1706.29)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f6d7a8",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.53"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f3cfa0",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.87"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f1ca9a",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear24",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(0.62,14.63,-14.63,0.62,177.16,180.28)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#e8d9d7",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#efe5e4",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.4"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#fff",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear25",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-61.8176,-279.259,279.259,-61.8176,10772.4,1242.6)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f6d7a8",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.53"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f3cfa0",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.87"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f1ca9a",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear26",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-558.699,-62.2091,62.2091,-558.699,2880.62,1586.24)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#fbdbaf",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear27",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-1.84,-21.57,21.57,-1.84,209.22,155.36)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f6d7a8",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.52"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f3cfa0",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.85"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0c999",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear28",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-75.8413,-681.417,681.417,-75.8413,6258.81,5156.43)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f6d7a8",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.52"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f3cfa0",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.85"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0c999",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear29",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(36.51,10.28,-10.28,36.51,128,137.3)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f0c999",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#e4b586",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.52"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#dba779",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear30",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-23.41,-5.65,5.65,-23.41,159.84,146.83)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#ece7e7",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f6f4f4",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.23"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#fdfcfc",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.53"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#fff",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear31",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-24.62,0.99,-0.99,-24.62,155.24,143.99)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#94958d",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#c5c6c0",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear32",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(421.136,108.01,-108.01,421.136,2453.09,1291.11)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#94958d",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#c5c6c0",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('radialGradient', {
    attrs: {
      "id": "_Radial33",
      "cx": "0",
      "cy": "0",
      "r": "1",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(15.6,0,0,15.6,151.04,147.45)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#2a3a3b",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#1c2727",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear34",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(26.76,-1.27,1.27,26.76,131.02,140.09)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#673024",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#53271c",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.34"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#462118",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.68"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#421f16",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear35",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(1292.07,191.107,-191.107,1292.07,7068.09,2759.41)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f0c999",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#e4b586",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.52"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#dba779",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear36",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-651.744,-84.298,84.298,-651.744,6459.34,2384.27)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#ece7e7",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f6f4f4",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.23"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#fdfcfc",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.53"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#fff",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear37",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-440.693,13.5819,-13.5819,-440.693,4034.79,2132.55)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#94958d",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#c5c6c0",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear38",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(489.614,107.919,-107.919,489.614,3485.96,1114.97)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#94958d",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#c5c6c0",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('radialGradient', {
    attrs: {
      "id": "_Radial39",
      "cx": "0",
      "cy": "0",
      "r": "1",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(165.355,0,0,165.355,2428.79,1701.77)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#2a3a3b",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#1c2727",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear40",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(729.291,-11.1312,11.1312,729.291,5488.14,1378.13)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#673024",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#53271c",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.34"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#462118",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.68"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#421f16",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear41",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-32.45,-62.11,62.11,-32.45,144.74,232.33)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f6d7aa",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0c998",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear42",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(30.81,-63.37,63.37,30.81,209.65,234.4)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f6d7aa",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#ffddb2",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear43",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(8.31,130.89,-130.89,8.31,168.58,12.14)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f3d0a1",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.45"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0c999",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear44",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-100.572,2552.87,-2552.87,-100.572,5332.93,7306.56)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f3d0a1",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.45"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0c999",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear45",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-51.2144,805.696,-805.696,-51.2144,10574.8,5929.45)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f3d0a1",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.45"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0c999",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear46",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(-98.2044,3308.34,-3308.34,-98.2044,7302.33,7662.72)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f3d0a1",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.45"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f0c999",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear47",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(0.2325,6.009,-6.009,0.2325,196.599,45.8152)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#673024",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#53271c",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.34"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#462118",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.68"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#421f16",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear48",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(1.36,56.85,-56.85,1.36,176.17,112.88)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#ffdeb3",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#fdddb1",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.2"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear49",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(33.2092,483.988,-483.988,33.2092,6265.67,2355.8)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f6d7a8",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.53"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f3cfa0",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.87"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f1ca9a",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "_Linear50",
      "x1": "0",
      "y1": "0",
      "x2": "1",
      "y2": "0",
      "gradientUnits": "userSpaceOnUse",
      "gradientTransform": "matrix(1.92,-14.18,14.18,1.92,176.08,172.59)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#ffdeb3",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#fbdcaf",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "0.28"
    }
  }), _c('stop', {
    staticStyle: {
      "stop-color": "#f7d9ab",
      "stop-opacity": "1"
    },
    attrs: {
      "offset": "1"
    }
  })], 1)], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d889529","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/avatar/components/stub/ChildrenAvatarStub.vue
// module id = f8ea3bf2d16f968f1d37
// module chunks = 89